<template>
  <div>
    <h3 class="mb-2">Membresías</h3>
    <!-- <button @click="test()">HOLA</button> -->

    <div class="d-flex flex-column d-md-block">
      <!-- DETAILS -->
      <div
        v-if="showDetails"
        class="btn-group d-md-none my-2 mx-auto"
        role="group"
        aria-label="Membership/Customer detail toggle"
      >
        <button
          type="button"
          @click="mobileDetailToggle = 'CUSTOMER'"
          class="btn btn-secondary"
        >
          SOCIO
        </button>
        <button
          type="button"
          @click="mobileDetailToggle = 'MEMBERSHIP'"
          class="btn btn-secondary rounded-left"
        >
          MEMBRESIA
        </button>
        <button
          type="button"
          @click="backToSearch()"
          class="btn btn-secondary rounded-right"
        >
          BUSCAR
        </button>
      </div>
      <transition
        name="fade"
        enter-active-class="animate__animated animate__fadeInDown"
        leave-active-class="animate__animated animate__fadeOutUp"
        class="animate__delay-2s"
      >
        <div v-if="showDetails" class="d-md-flex">
          <!-- MEMBERSHIP DETAILS -->
          <div
            v-if="mobileDetailToggle !== 'CUSTOMER'"
            class="col-md-8 container-fluid px-0 pr-2"
          >
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <h5 class="title">Detalle Membresia</h5>
                <div class="">
                  <label class="mr-2">Estado</label>
                  <el-select
                    class="select-default"
                    size="small"
                    v-model="foundMembership.estadoPago"
                    placeholder="sin membresía"
                    :disabled="membershipReadOnly"
                  >
                    <el-option
                      class="select-default"
                      v-for="item in pagination.catalog.slice(2)"
                      :key="item._id.$oid"
                      :label="item.glosa"
                      :value="item.glosa"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="card-body">
                <form>
                  <div class="row">
                    <div class="col-6 col-md-5">
                      <label for="">Familia</label>
                      <input
                        type="text"
                        label="Familia"
                        class="form-control"
                        placeholder="Sin membresía"
                        v-model.trim="foundMembership.nombreFamilia"
                        :readonly="true"
                      />
                    </div>
                    <div class="col-6 col-md-3">
                      <label for="">Sub Familia</label>
                      <input
                        type="text"
                        size="small"
                        label="Sub Familia"
                        class="form-control"
                        placeholder="Sin membresía"
                        v-model.trim="foundMembership.nombreSubFamilia"
                        :readonly="true"
                      />
                    </div>
                    <div class="col-4 col-md-4">
                      <label for="">Turno</label>
                      <div class="d-flex flex-row">
                        <input
                          type="text"
                          label="Turno"
                          size="small"
                          class="form-control"
                          placeholder="Sin membresía"
                          v-model="foundMembership.turno.descripcionTurno"
                          :readonly="true"
                          :class="
                            foundMembership.turno.descripcionTurno
                              ? 'col-10'
                              : ''
                          "
                        />
                        <el-tooltip :open-delay="200" placement="top">
                          <template #content>
                            {{
                              membershipReadOnly ? "Ver turno" : "Editar turno"
                            }}
                          </template>
                          <i
                            v-if="foundMembership.turno.descripcionTurno"
                            @click="test"
                            class="fa m-auto cursor-pointer"
                            :class="
                              membershipReadOnly
                                ? 'fa-search fa-2x text-info'
                                : 'fa-cog fa-2x text-success'
                            "
                            aria-hidden="true"
                          ></i
                        ></el-tooltip>
                      </div>
                    </div>
                    <div class="col-8 d-md-none">
                      <label for="">Plan</label>
                      <input
                        type="text"
                        label="Plan"
                        size="small"
                        class="form-control"
                        placeholder="Sin membresía"
                        v-model.trim="foundMembership.descripcionPlan"
                        :readonly="membershipReadOnly"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="d-none d-md-block col-md-6">
                      <label for="">Plan</label>
                      <input
                        type="text"
                        label="Plan"
                        size="small"
                        class="form-control"
                        placeholder="Sin membresía"
                        v-model.trim="foundMembership.descripcionPlan"
                        :readonly="membershipReadOnly"
                      />
                    </div>
                    <div class="col-5">
                      <label for="">Sucursal Asignación</label>
                      <input
                        type="text"
                        label=""
                        size="small"
                        class="form-control"
                        placeholder="Sin membresía"
                        v-model="foundMembership.nombreSucursalAsignacion"
                        :readonly="true"
                      />
                    </div>
                    <div class="col-7 d-md-none">
                      <label for="">Duración</label>
                      <div class="d-flex flex-row">
                        <input
                          type="number"
                          id="duracionPlan"
                          placeholder="0"
                          size="small"
                          class="w-50 form-control"
                          min="1"
                          @input="validatePositive"
                          v-model.number="foundMembership.duracionPlan"
                          :readonly="membershipReadOnly"
                        />
                        <el-select
                          id="unidadExpiracionRenovacion"
                          v-model="foundMembership.unidadDuracionPlan"
                          placeholder="Selecciona"
                          class="success"
                          size="small"
                          :disabled="membershipReadOnly"
                        >
                          <el-option
                            el-option
                            v-for="(
                              cat, index
                            ) in plansCatalogs.unidadDuracionPlan"
                            :key="index"
                            :label="cat.glosa"
                            :value="cat.glosa"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-4 d-none d-md-block">
                      <label for="">Duración</label>
                      <div class="d-flex flex-row">
                        <input
                          type="number"
                          id="duracionPlan"
                          placeholder="0"
                          size="small"
                          class="w-50 form-control"
                          min="1"
                          @input="validatePositive"
                          v-model.number="foundMembership.duracionPlan"
                          :readonly="membershipReadOnly"
                        />
                        <el-select
                          id="unidadExpiracionRenovacion"
                          v-model="foundMembership.unidadDuracionPlan"
                          placeholder="Selecciona"
                          class="success"
                          size="small"
                          :disabled="membershipReadOnly"
                        >
                          <el-option
                            el-option
                            v-for="(
                              cat, index
                            ) in plansCatalogs.unidadDuracionPlan"
                            :key="index"
                            :label="cat.glosa"
                            :value="cat.glosa"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="col-3 col-md-2">
                      <label>Descuento</label>
                      <el-select
                        v-model="selectedDiscount"
                        placeholder="Selecciona"
                        class="success"
                        size="small"
                        :disabled="membershipReadOnly"
                      >
                        <el-option
                          v-for="(item, index) in discounts"
                          :key="index"
                          :value="item"
                          >{{ item }}%</el-option
                        >
                      </el-select>
                    </div>
                    <div class="col-2 d-flex switch d-flex flex-column m-auto">
                      <label class="mx-auto text-nowrap">Multi-sede</label>
                      <p-switch
                        v-model="foundMembership.informacionAdicional.multiSede"
                        type="success"
                        class="mx-auto"
                        size="small"
                        on-text="SI"
                        off-text="NO"
                        :readonly="membershipReadOnly"
                      ></p-switch>
                    </div>
                    <div class="col-md col d-flex">
                      <div class="switch d-flex flex-column m-auto">
                        <label class="mx-auto text-nowrap"
                          >¿Permite Congelar?</label
                        >
                        <p-switch
                          v-model="filters.indicadorPermiteCongelar"
                          type="success"
                          class="mx-auto"
                          size="small"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                      <div
                        v-if="foundMembership.diasPermitidoCongelar > 0"
                        class="d-flex flex-column pl-3"
                      >
                        <label for="diasConelar">Dias para Congelar</label>
                        <input
                          type="number"
                          id="diasConelar"
                          placeholder="0"
                          label="Dias para Congelar"
                          class="form-control"
                          min="0"
                          @input="validatePositive"
                          size="small"
                          v-model.number="foundMembership.diasPermitidoCongelar"
                          :readonly="membershipReadOnly"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-md-4">
                      <label class="">Valor</label>
                      <input
                        id="valorPlan"
                        type="number"
                        label="Valor"
                        placeholder="$0"
                        class="form-control"
                        size="small"
                        min="0"
                        @input="validatePositive"
                        v-model.number="foundMembership.valorPlan"
                        :readonly="membershipReadOnly"
                      />
                    </div>
                    <div class="col-6 col-md-4 my-auto d-flex flex-column">
                      <label class="mb-0" style="color: #9a9a9a">IVA</label>

                      <el-select
                        v-model="foundMembership.tipoIVA"
                        placeholder="Selecciona"
                        class="success"
                        size="small"
                        :disabled="membershipReadOnly"
                      >
                        <el-option label="EXENTO" value="EXENTO"></el-option>
                        <el-option label="AFECTO" value="AFECTO"></el-option>
                      </el-select>
                    </div>
                    <div class="d-none d-md-flex flex-column col-6 col-md-4">
                      <label for="datePickerfechaUltimoPago">Ultimo Pago</label>
                      <el-date-picker
                        id="datePickerfechaUltimoPago"
                        type="date"
                        label="Ultimo Pago"
                        size="small"
                        class="w-auto"
                        placeholder="01-01-1900"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="foundMembership.fechaUltimoPago"
                        :readonly="membershipReadOnly"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                  <div class="row d-flex flex-row">
                    <div class="d-flex flex-column col-6 col-md-4 d-md-none">
                      <label for="datePickerfechaUltimoPago">Ultimo Pago</label>
                      <el-date-picker
                        id="datePickerfechaUltimoPago"
                        type="date"
                        label="Ultimo Pago"
                        size="small"
                        class="w-auto"
                        placeholder="01-01-1900"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="foundMembership.fechaUltimoPago"
                        :readonly="membershipReadOnly"
                      >
                      </el-date-picker>
                    </div>
                    <div class="col-6 col-md-4 d-flex flex-column">
                      <label for="datePickerfechaInicio">Fecha Inicio</label>
                      <el-date-picker
                        id="datePickerfechaInicio"
                        type="date"
                        size="small"
                        class="w-auto"
                        placeholder="01-01-1900"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="foundMembership.fechaInicio"
                        :readonly="membershipReadOnly"
                      >
                      </el-date-picker>
                    </div>
                    <div class="col-6 col-md-4 d-flex flex-column my-auto">
                      <label for="datePickerfechaVencimiento"
                        >Fecha Vencimiento</label
                      >
                      <el-date-picker
                        id="datePickerfechaVencimiento"
                        type="date"
                        placeholder="01-01-1900"
                        format="dd-MM-yyyy"
                        size="small"
                        class="w-auto"
                        value-format="dd-MM-yyyy"
                        v-model="foundMembership.fechaVencimiento"
                        :readonly="membershipReadOnly"
                      >
                      </el-date-picker>
                    </div>
                    <div class="col-6 col-md-4">
                      <label for="datePickerfechaAsignacion"
                        >Fecha Asignacion</label
                      >
                      <el-date-picker
                        id="datePickerfechaAsignacion"
                        type="date"
                        placeholder="01-01-1900"
                        size="small"
                        class="w-auto"
                        format="dd-MM-yyyy"
                        v-model="foundMembership.fechaAsignacion"
                        :readonly="membershipReadOnly"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                  <div
                    class="container mt-2 d-flex justify-content-start flex-wrap flex-md-nowrap px-0"
                  >
                    <div
                      class="container d-flex px-0 flex-row flex-md-column col-md-2"
                      :class="{
                        'col-12 px-md-auto':
                          foundMembership.indicadorUsoSesiones,
                        'col-2': !foundMembership.indicadorUsoSesiones,
                      }"
                    >
                      <div class="switch d-flex flex-column">
                        <label class="mx-auto">Sesiones</label>
                        <p-switch
                          v-model="foundMembership.indicadorUsoSesiones"
                          type="success"
                          class="my-auto mx-md-auto mr-2"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                      <div
                        v-if="foundMembership.indicadorUsoSesiones"
                        class="row switch-body d-md-block justify-content-md-center"
                      >
                        <div class="text-center text-center col mb-0">
                          <label class="my-auto">Utilizadas</label>
                          <input
                            type="number"
                            @input="validatePositive"
                            id="sesionesUtilizadas"
                            placeholder="0"
                            class="form-control"
                            size="small"
                            v-model.number="foundMembership.sesionesUtilizadas"
                            :readonly="membershipReadOnly"
                            min="0"
                          />
                        </div>
                        <div class="text-center text-center mt-0 col">
                          <label class="my-auto w-75">Max</label>
                          <input
                            class="form-control"
                            type="number"
                            @input="validatePositive"
                            id="sesionesLimite"
                            placeholder="0"
                            min="0"
                            size="small"
                            v-model.number="foundMembership.sesionesLimite"
                            :readonly="membershipReadOnly"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-2 px-0"
                      :class="{
                        'col-8 px-0 px-md-auto d-flex flex-row flex-md-column':
                          foundMembership.indicadorMesCalendario,
                        'col-3': !foundMembership.indicadorMesCalendario,
                      }"
                    >
                      <div class="switch d-flex flex-column px-4">
                        <label class="mx-auto text-nowrap">
                          Mes Calendario
                        </label>
                        <p-switch
                          v-model="foundMembership.indicadorMesCalendario"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                      <div
                        v-if="foundMembership.indicadorMesCalendario"
                        class="row switch-body d-flex justify-content-center"
                      >
                        <el-tooltip :open-delay="200" placement="top">
                          <template #content>
                            Esta opción te permite personalizar la duración del
                            mes<br />
                            Por ejemplo, al seleccionar 30 días, <br />
                            todos los meses tendrán la misma duración de 30
                            días.
                          </template>
                          <div class="text-center text-center">
                            <label class="my-auto">Días del mes</label>
                            <input
                              @input="validatePositive"
                              id="diasMesNoCalendario"
                              type="number"
                              placeholder="0"
                              min="0"
                              size="small"
                              class="col-10 form-control mx-auto"
                              v-model.number="
                                foundMembership.diasMesNoCalendario
                              "
                              :readonly="membershipReadOnly"
                            />
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="container col-auto col-md-2">
                      <div class="switch d-flex flex-column">
                        <label class="mx-auto">Factura</label>
                        <p-switch
                          v-model="foundMembership.indicadorFactura"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                    </div>
                    <div
                      class="px-0"
                      :class="{
                        'col-md-3 col-12 d-flex flex-row flex-md-column':
                          foundMembership.indicadorPermiteRenovar,
                        'col-2 col-md-2':
                          !foundMembership.indicadorPermiteRenovar,
                      }"
                    >
                      <div class="switch d-flex flex-column mr-2 mx-md-auto">
                        <label class="mx-auto">Renovar</label>
                        <p-switch
                          v-model="foundMembership.indicadorPermiteRenovar"
                          type="success"
                          class="mx-auto mt-md-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                      <div
                        v-if="foundMembership.indicadorPermiteRenovar"
                        class="mt-0 text-center d-flex flex-row align-items-bottom"
                      >
                        <div
                          v-if="
                            foundMembership.unidadExpiracionRenovacion !==
                            'INDEFINIDA (I)'
                          "
                        >
                          <label for="expiracionRenovacion" class=""
                            >Cant</label
                          >
                          <input
                            @input="validatePositive"
                            id="expiracionRenovacion"
                            type="number"
                            label="Cantidad"
                            min="0"
                            size="small"
                            v-model.number="
                              foundMembership.expiracionRenovacion
                            "
                            class="form-control"
                            placeholder=""
                            :readonly="membershipReadOnly"
                          />
                        </div>
                        <div class="px-0 mx-0 d-flex flex-column">
                          <label
                            for="unidadExpiracionRenovacion"
                            class="mx-auto"
                            >Unidad</label
                          >
                          <el-select
                            id="unidadExpiracionRenovacion"
                            v-model="foundMembership.unidadExpiracionRenovacion"
                            placeholder="Selecciona"
                            class="success"
                            :class="
                              foundMembership.unidadExpiracionRenovacion ===
                              'INDEFINIDA (I)'
                                ? 'w-75 mx-auto'
                                : ''
                            "
                            size="small"
                            :disabled="membershipReadOnly"
                          >
                            <el-option
                              el-option
                              v-for="(
                                cat, index
                              ) in plansCatalogs.unidadExpiracionRenovacion"
                              :key="index"
                              :label="cat.glosa"
                              :value="cat.glosa"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-md-2 px-0"
                      :class="{
                        'col-12 col-md-2 d-flex flex-row flex-md-column':
                          foundMembership.indicadorMatricula,
                        'col-3 col-md-2': !foundMembership.indicadorMatricula,
                      }"
                    >
                      <div class="switch d-flex flex-column">
                        <label class="mx-auto">Matricula</label>
                        <p-switch
                          v-model="foundMembership.indicadorMatricula"
                          type="success"
                          class="mx-auto"
                          on-text="SI"
                          off-text="NO"
                          :readonly="membershipReadOnly"
                        ></p-switch>
                      </div>
                      <div
                        v-if="foundMembership.indicadorMatricula"
                        class="switch-body d-md-block d-flex flex-row"
                      >
                        <div class="text-center col-6 col-md">
                          <label class="mb-0 mr-2">Valor</label>
                          <input
                            @input="validatePositive"
                            id="valorMatricula"
                            type="number"
                            placeholder="$0"
                            min="0"
                            class="form-control"
                            size="small"
                            v-model.number="foundMembership.valorMatricula"
                            :readonly="membershipReadOnly"
                          />
                        </div>
                        <div class="text-center col">
                          <label class="mb-0 mr-2">Fecha</label>
                          <p>
                            {{
                              foundMembership.fechaPagoMatricula || "dd-MM-aaaa"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="foundMember.type === 'CARGA'"
                    class="col-12 text-danger mt-4 d-flex flex-column"
                  >
                    <small class="font-weight-bold mx-auto text-center">
                      {{
                        foundMember.agreementHolder
                          ? `ESTE ES UN SOCIO DE TIPO [CARGA], CAMBIA SU TIPO EN
                      "EDITAR SOCIO" O VE A LA MEMBRESÍA DEL TITULAR: `
                          : `ESTE ES UN SOCIO DE TIPO [CARGA], CAMBIA SU TIPO O ASIGNALO A UN CONVENIO EN
                      "EDITAR SOCIO"`
                      }}</small
                    >
                    <div
                      class="w-auto btn mx-auto btn-sm btn-warning"
                      @click="
                        memberDetails({
                          rut: foundMember.agreementHolder,
                        })
                      "
                      v-if="foundMember.agreementHolder"
                    >
                      {{ foundMember.agreementHolder }}
                    </div>
                    <el-tooltip
                      v-if="activeMembershipID"
                      :open-delay="200"
                      placement="top"
                      class="d-none d-md-block"
                    >
                      <template #content>
                        Eliminar Membresía, el sistema no toma en cuenta las
                        membresías asignadas a socios de tipo [CARGA]
                      </template>
                      <button
                        v-if="activeMembershipID"
                        type="button"
                        class="btn btn-outline-danger rounded-circle px-2 mx-auto"
                        style="
                          height: 50px;
                          width: 50px;
                          right: 20px;
                          bottom: 10px;
                        "
                        @click="
                          deleteMembership(
                            foundMember.nationalId,
                            foundMembership.descripcionPlan
                          )
                        "
                      >
                        <i
                          class="fa fa-trash fa-2x ml-0 pl-0"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </el-tooltip>
                  </div>
                  <div
                    v-else
                    class="text-center my-2 mt-md-4 d-flex justify-content-center"
                  >
                    <button
                      v-if="!activeMembershipID"
                      type=""
                      class="btn btn-info btn-fill btn-wd rounded-pill"
                      @click.prevent="memebrshipAsingmentStart()"
                    >
                      asignar membresía
                    </button>
                    <button
                      v-if="membershipReadOnly && activeMembershipID"
                      type=""
                      class="btn btn-info btn-fill btn-wd"
                      @click.prevent="enableMembershipEdit()"
                    >
                      editar
                    </button>
                    <button
                      v-if="!membershipReadOnly && activeMembershipID"
                      type="submit"
                      class="btn btn-success btn-fill btn-wd"
                      @click.prevent="saveMembershipChanges()"
                    >
                      guardar
                    </button>
                    <button
                      v-if="!membershipReadOnly && activeMembershipID"
                      type="submit"
                      class="btn btn-danger btn-fill btn-wd ml-4"
                      @click.prevent="cancelMembershipEdit()"
                    >
                      cancelar
                    </button>
                    <el-tooltip
                      v-if="!membershipReadOnly && activeMembershipID"
                      :open-delay="200"
                      placement="top"
                      class="d-none d-md-block"
                    >
                      <template #content> Eliminar Membresía </template>
                      <button
                        v-if="!membershipReadOnly && activeMembershipID"
                        type="button"
                        class="btn btn-outline-danger rounded-circle px-2 position-absolute"
                        style="
                          height: 50px;
                          width: 50px;
                          right: 20px;
                          bottom: 10px;
                        "
                        @click="
                          deleteMembership(
                            foundMember.nationalId,
                            foundMembership.descripcionPlan
                          )
                        "
                      >
                        <i
                          class="fa fa-trash fa-2x ml-0 pl-0"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="col-12 d-flex">
                    <el-tooltip
                      v-if="!membershipReadOnly && activeMembershipID"
                      :open-delay="200"
                      placement="top"
                      class="d-md-none"
                    >
                      <template #content> Eliminar Membresía </template>
                      <button
                        v-if="!membershipReadOnly && activeMembershipID"
                        type="button"
                        class="btn btn-outline-danger rounded-circle px-2 mx-auto"
                        style="
                          height: 50px;
                          width: 50px;
                          right: 20px;
                          bottom: 10px;
                        "
                        @click="
                          deleteMembership(
                            foundMember.nationalId,
                            foundMembership.descripcionPlan
                          )
                        "
                      >
                        <i
                          class="fa fa-trash fa-2x ml-0 pl-0"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="clearfix"></div>
                </form>
              </div>
            </div>
          </div>
          <!-- MEMBER DATAILS -->
          <div
            v-if="mobileDetailToggle !== 'MEMBERSHIP'"
            class="card card-user col-md-4"
          >
            <div class="card-body">
              <div class="author d-none d-md-block">
                <a href="#">
                  <img
                    v-if="foundMember.avatar"
                    class="avatar border-gray"
                    :src="foundMember.avatar"
                    alt="..."
                  />
                  <img
                    v-else
                    class="avatar border-gray"
                    src="static/img/faces/avatar.png"
                    alt="..."
                  />
                  <h5 class="title">{{ foundMember.name || "No Data" }}</h5>
                </a>
                <p class="description">{{ foundMember.email || "No Email" }}</p>
              </div>
              <div class="d-md-none container-fluid d-flex flex-column">
                <img
                  v-if="foundMember.avatar"
                  class="avatar border-gray mx-auto"
                  :src="foundMember.avatar"
                  alt="..."
                />
                <img
                  v-else
                  class="avatar border-gray mx-auto"
                  src="static/img/faces/avatar.png"
                  alt="..."
                />
                <h5 class="title mx-auto text-center">
                  {{ foundMember.name || "No Data" }}
                </h5>
                <p class="description text-center">
                  {{ foundMember.email || "No Email" }}
                </p>
              </div>
              <div class="row">
                <div
                  class="col-6 px-0 my-2 border-right d-flex flex-column justify-content-center"
                >
                  <div class="container w-100 row px-0 text-center">
                    <i class="fa fa-id-card fa-lg col-4" aria-hidden="true"></i>
                    <p class="pb-0 mb-1">
                      {{ foundMember.nationalId || "No Data" }}
                    </p>
                  </div>
                  <div class="container-fluid row flex-nowrap px-0 text-center">
                    <i class="fa fa-phone fa-lg col-4" aria-hidden="true"></i>
                    <p class="pb-0 mb-1">
                      {{
                        foundMember.phoneMobile ||
                        foundMember.phone ||
                        "No Data"
                      }}
                    </p>
                  </div>
                  <div class="container-fluid row px-0 text-center flex-nowrap">
                    <i
                      class="fa fa-map-marker fa-lg col-4"
                      aria-hidden="true"
                    ></i>
                    <small
                      ><p class="">
                        {{ foundMember.branch || "No Data" }}
                      </p></small
                    >
                  </div>
                </div>
                <div class="col-6 my-4">
                  <p class="border-bottom mb-1">
                    <small><strong>Dirección:</strong></small>
                  </p>
                  <small>
                    <p class="mb-1">
                      {{
                        foundMember.address || "Siempreviva #742, Springfield"
                      }}
                    </p>
                    <p v-if="foundMember.state" class="mb-1">
                      R: {{ foundMember.state }}
                    </p>
                    <p v-if="foundMember.country">
                      <i class="fa fa-globe" aria-hidden="true"></i>
                      {{ foundMember.country }}
                    </p>
                  </small>
                </div>
                <div class="container-fluid d-flex flex-wrap">
                  <div class="mx-2">
                    <p class="mb-0 border-bottom"><small>Perfil</small></p>
                    <p>{{ foundMember.type }}</p>
                  </div>
                  <div class="mx-2">
                    <p class="mb-0 border-bottom"><small>Inscripción</small></p>
                    <p>{{ foundMember.registrationDate }}</p>
                  </div>
                  <div class="mx-2">
                    <p class="mb-0 border-bottom">
                      <small>Ultimo Pago</small>
                    </p>
                    <p>
                      {{
                        foundMembership.fechaUltimoPago.split("T")[0] ||
                        `sin membresía`
                      }}
                    </p>
                  </div>
                  <div class="mx-2">
                    <p class="mb-0 border-bottom">
                      <small>Prom Visitas</small>
                    </p>
                    <p>6 /Mes</p>
                  </div>
                  <div class="mx-2">
                    <p class="mb-0 border-bottom">
                      <small>Sucursal Favorita</small>
                    </p>
                    <p>{{ foundMemberAccesResum.bestBranch || "No Data" }}</p>
                  </div>
                  <div class="mx-2">
                    <p class="mb-0 border-bottom">
                      <small>Días Favoritos</small>
                    </p>
                    <p>
                      {{
                        foundMemberAccesResum.bestDaysOfWeek || "**** - ****"
                      }}
                    </p>
                  </div>
                  <template v-if="activeMembershipID">
                    <div class="mx-2">
                      <p class="mb-0 border-bottom">
                        <small>Ultimo Acceso</small>
                      </p>
                      <p>
                        {{
                          foundMembership.fechaHoraUltimoAcceso
                            ? foundMembership.fechaHoraUltimoAcceso.split(
                                " "
                              )[0]
                            : "No Data"
                        }}
                      </p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <template v-if="couldBePayed">
              <button
                type=""
                class="btn btn-info btn-fill btn-wd w-100 mb-0"
                @click="
                  handleOnlinePayment(
                    foundMember,
                    foundMembership._id,
                    foundMembership.estadoPago
                  )
                "
              >
                {{
                  foundMembership.estadoPago === "PENDIENTE"
                    ? "pago en linea"
                    : "renovación en linea"
                }}
              </button>
            </template>
            <button
              type=""
              class="btn btn-info btn-fill btn-wd w-100 mb-0"
              @click="handleShowMembershipLog(foundMember.nationalId)"
            >
              historial
            </button>
            <button
              type=""
              class="btn btn-info btn-fill btn-wd w-100 mb-4"
              @click="goToCustomerDetails(foundMember.nationalId)"
            >
              editar socio
            </button>
          </div>
        </div>
      </transition>
      <!-- END DATILS -->
      <div class="container-fluid d-flex justify-content-between p-0 m-0">
        <span class=""
          >Total:
          <badge class="" slot="title-label" type="success">{{
            filterResultTotal
          }}</badge></span
        >
      </div>

      <div class="card mt-2">
        <div class="card-header d-flex justify-content-between">
          <div class="category">BUSCADOR DE MEMBRESIAS</div>
          <i
            class="fa fa-refresh text-success pointer"
            aria-hidden="true"
            @click="refreshTable()"
          ></i>
        </div>
        <div class="card-body row">
          <div class="d-none w-100 d-md-flex col-12 flex-row">
            <div class="col d-flex flex-column">
              <label for="subfamilys-dropdown">Estados</label>
              <el-select
                class="select-default"
                v-model="pagination.currentFilter"
                placeholder="Per page"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.catalog"
                  :key="item._id.$oid"
                  :label="item.glosa"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col d-flex flex-column">
              <label for="subfamilys-dropdown">Familias</label>
              <el-select
                class="select-default"
                v-model="selectedFamily"
                placeholder="Familias"
              >
                <el-option
                  class="select-default"
                  v-for="item in familysCatalog"
                  :key="item._id.$oid"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col d-flex flex-column">
              <label for="subfamilys-dropdown">Sub-Familias</label>
              <el-select
                id="subfamilys-dropdown"
                class="select-default"
                v-model="selectedSubFamily"
                placeholder="SubFamilias"
              >
                <!-- <el-option
                class="select-default"
                :label="'TODAS'"
                :value="JSON.stringify({ _id: 0, nombre: 'TODAS' })"
              >
              </el-option> -->
                <el-option
                  class="select-default"
                  v-for="item in subFamilysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col d-flex flex-column">
              <label for="plans-dropdown">Planes</label>
              <el-select
                class="select-default"
                v-model="selectedPlan"
                placeholder="Planes"
                id="plans-dropdown"
              >
                <!-- <el-option
                class="select-default"
                :label="'TODOS'"
                :value="JSON.stringify({ _id: 0, nombre: 'TODOS' })"
              >
              </el-option> -->
                <el-option
                  class="select-default"
                  v-for="item in plansCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col d-flex pt-md-4">
              <fg-input
                class="d-none d-md-flex input-sm m-auto align-bottom"
                placeholder="BUSCAR"
                @keyup.enter="searchMembership"
                v-model.trim="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              >
              </fg-input>
              <div class="pt-4 pb-2 d-md-none">
                <fg-input
                  class="input-sm"
                  placeholder="BUSCAR"
                  @keyup.enter="searchMembership"
                  v-model.trim="searchQuery"
                  addon-right-icon="nc-icon nc-zoom-split"
                >
                </fg-input>
              </div>
            </div>
          </div>
          <div class="row d-md-none px-2">
            <div class="col-4">
              <button
                class="btn rounded-pill my-auto"
                @click="toggleMobileFilters"
                :class="mobileFilter ? 'btn-primary' : 'btn-info'"
              >
                {{ mobileFilter ? "Ocultar" : "Filtrar" }}
              </button>
            </div>
            <div class="col-8 d-flex flex-row">
              <fg-input
                class="input-sm"
                placeholder="BUSCAR"
                v-model.trim="searchQuery"
                @keyup.enter="searchMembership"
              >
                <!-- addon-right-icon="nc-icon nc-zoom-split" -->
              </fg-input>
              <button
                class="btn btn-info ml-1 p-0 round-button rounded-circle mt-0"
                style="height: 40px; width: 45px"
              >
                <i
                  role="button"
                  class="fa fa-search fa-2x"
                  @click="searchMembership"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
          <div v-if="mobileFilter" class="d-flex flex-wrap">
            <div class="col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Estados</label>
              <el-select
                class="select-default"
                v-model="pagination.currentFilter"
                placeholder="Per page"
                size="small"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.catalog"
                  :key="item._id.$oid"
                  :label="item.glosa"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Familias</label>
              <el-select
                class="select-default"
                v-model="selectedFamily"
                placeholder="Familias"
                size="small"
              >
                <el-option
                  class="select-default"
                  v-for="item in familysCatalog"
                  :key="item._id.$oid"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-6 d-flex flex-column">
              <label for="subfamilys-dropdown">Sub-Familias</label>
              <el-select
                id="subfamilys-dropdown"
                class="select-default"
                v-model="selectedSubFamily"
                placeholder="SubFamilias"
                size="small"
              >
                <el-option
                  class="select-default"
                  v-for="item in subFamilysCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-6 d-flex flex-column">
              <label for="plans-dropdown">Planes</label>
              <el-select
                class="select-default"
                v-model="selectedPlan"
                placeholder="Planes"
                id="plans-dropdown"
                size="small"
              >
                <el-option
                  class="select-default"
                  v-for="item in plansCatalog"
                  :key="item._id"
                  :label="item.nombre"
                  :value="JSON.stringify(item)"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div v-if="!this.tableIsLoading && isMounted" class="col-sm-12 mt-2">
            <el-table
              class="table-striped d-none d-md-block"
              :data="membershipsData"
              style="width: 100%"
              @row-click="memberDetails"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                class-name="text-nowrap"
              >
              </el-table-column>
            </el-table>
            <table class="table table-striped d-md-none">
              <thead>
                <tr>
                  <th scope="col">RUT</th>
                  <th scope="col">NOMBRE</th>
                  <!-- <th scope="col">PLAN</th> -->
                  <th scope="col">ESTADO</th>
                  <!-- <th scope="col" class="text-center">
                    <i class="fa fa-arrow-down"></i>
                  </th> -->
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in membershipsData" :key="item.id">
                  <th
                    @click="
                      memberDetails(item);
                      mobileDetailToggle = 'CUSTOMER';
                    "
                    scope="row"
                    class="text-center text-nowrap"
                  >
                    <a>
                      <small>{{ item.rut }}</small></a
                    >
                  </th>
                  <td
                    @click="
                      memberDetails(item);
                      mobileDetailToggle = 'CUSTOMER';
                    "
                    class="text-nowrap mobile-table-text"
                  >
                    <a
                      ><small>{{ item.name }}</small></a
                    >
                  </td>
                  <!-- <td @click="memberDetails(item)" class="p-0">
                    <a
                      ><small>{{ item.membership }}</small></a
                    >
                  </td> -->
                  <td
                    @click="
                      memberDetails(item);
                      mobileDetailToggle = 'CUSTOMER';
                    "
                    class="p-0"
                  >
                    <a
                      ><small>{{ item.status }}</small></a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="this.tableIsLoading && isMounted"
            class="container-fluid d-flex"
          >
            <Loading class="mx-auto"></Loading>
          </div>

          <div class="col-sm-6 container-fluid d-flex mt-4">
            <p-pagination
              class="pull-right mx-auto"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            >
              <!-- @input="onPageChange" -->
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- MEMBERSHIP ASSIGNMENT MODALS-->
    <!-- Memberships Assignment START-->
    <modal :show.sync="MAModals.starter" type="notice">
      <template slot="header">
        <h5 class="font-weight-bold">ASIGNACIÓN DE MEMBRESIAS</h5>
      </template>
      <template slot="default">
        <div class="col d-flex flex-column text-center">
          <p class="lead">¿Como te gustaría comenzar?</p>
          <button
            class="btn btn-success col-6 mx-auto"
            @click="MAM_start(true)"
          >
            Muestrame todas las familias
          </button>
          <p class="lead">ó</p>
          <button
            class="btn btn-success col-6 mx-auto"
            @click="MAM_start(false)"
          >
            Vamos directo a los planes
          </button>
        </div>
      </template>
      <!-- <button type="button" class="btn">Siguiente</button> -->
    </modal>
    <!-- Family Select MODAL -->
    <modal :show.sync="MAModals.famSelect" type="notice">
      <template slot="header">
        <h5 class="font-weight-bold">SELECCIONA UNA FAMILIA</h5>
      </template>
      <template slot="default">
        <div class="col table-container">
          <table class="table table-hover col mb-0">
            <thead class="bg-warning rounded-top pl-4">
              <tr class="text-light pl-4">
                <th scope="col">#</th>
                <th scope="col">Nombre</th>
              </tr>
            </thead>
          </table>
          <div class="table table-hover col card table-body pr-0">
            <tbody class="table-body">
              <tr
                v-for="(fam, index) in familysCatalogMA"
                :key="index"
                style="cursor: pointer"
              >
                <th @click="MA__stepFamily(fam._id)" class="col-1" scope="row">
                  {{ index + 1 }}
                </th>
                <td @click="MA__stepFamily(fam._id)" class="col">
                  {{ fam.nombre }}
                </td>
              </tr>
            </tbody>
          </div>
        </div>
        <div
          class="btn btn-success rounded-circle text-center p-2 d-flex"
          style="height: 50px; width: 50px"
        >
          <i
            @click="MA_stepFamilyBack()"
            class="fa fa-arrow-left fa-3x ml-0 pl-0"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <!-- <button type="button" class="btn">Siguiente</button> -->
    </modal>
    <!-- SubFamily Select MODAL -->
    <modal :show.sync="MAModals.subFamSelect" type="notice">
      <template slot="header">
        <h5 class="font-weight-bold">SELECCIONA UNA SUB-FAMILIA</h5>
      </template>
      <template slot="default">
        <div class="col table-container">
          <table class="table table-hover col mb-0">
            <thead class="bg-warning rounded-top">
              <tr class="text-light">
                <th scope="col-1">#</th>
                <th scope="col-10">Nombre</th>
              </tr>
            </thead>
          </table>
          <div class="table table-hover col card table-body pr-0">
            <tbody class="table-body">
              <tr
                v-for="(subfam, index) in filteredSubFams"
                :key="index"
                style="cursor: pointer"
              >
                <th
                  @click="MA_stepSubFamily(subfam.id)"
                  class="col-1"
                  scope="row"
                >
                  {{ index + 1 }}
                </th>
                <td @click="MA_stepSubFamily(subfam.id)" class="col-9">
                  {{ subfam.nombre }}
                </td>
              </tr>
            </tbody>
          </div>
        </div>
        <div
          class="btn btn-success rounded-circle text-center p-2 d-flex"
          style="height: 50px; width: 50px"
        >
          <i
            @click="MA_stepSubFamilyBack()"
            class="fa fa-arrow-left fa-3x ml-0 pl-0"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <!-- <button type="button" class="btn">Siguiente</button> -->
    </modal>
    <!-- Plans Select MODAL -->
    <modal :show.sync="MAModals.planSelect" type="notice">
      <template slot="header">
        <div class="d-flex flex-column">
          <div class="text-left">
            <i
              class="text-info fa fa-question-circle"
              role="btn"
              style="font-size: 25px; cursor: pointer"
              aria-hidden="true"
              @click="showPlansInfoPopUp"
            ></i>
          </div>
          <h5 class="font-weight-bold mx-auto">SELECCIONA UN PLAN</h5>
        </div>
      </template>
      <template slot="default">
        <i class="btn-link" @click="selectedSubFamMA = ''">ver todos...</i>
        <div class="col table-container">
          <table class="table table-hover col mb-0">
            <thead class="bg-warning rounded-top">
              <tr class="text-light">
                <th scope="col-1">#</th>
                <th scope="col-10">Nombre</th>
              </tr>
            </thead>
          </table>
          <div class="table table-hover col card table-body pr-0">
            <tbody class="table-body">
              <tr
                v-for="(plan, index) in filteredPlansMA"
                :key="index"
                style="cursor: pointer"
              >
                <th
                  @click="MA_stepPlanHandle(plan.id)"
                  class="col-1"
                  scope="row"
                >
                  {{ index + 1 }}
                </th>
                <td @click="MA_stepPlanHandle(plan.id)" class="col-9">
                  {{ plan.descripcion }}
                </td>
              </tr>
            </tbody>
          </div>
        </div>
        <div
          class="btn btn-success rounded-circle text-center p-2 d-flex"
          style="height: 50px; width: 50px"
        >
          <i
            @click="MA_stepPlanBack()"
            class="fa fa-arrow-left fa-3x ml-0 pl-0"
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <!-- <button type="button" class="btn">Siguiente</button> -->
    </modal>
    <!-- Asignar Sucursal MODAL -->
    <modal v-if="MAModals.branchSelect" :show.sync="MAModals.branchSelect">
      <template slot="header">
        <h5 class="font-weight-bold">SELECCIONA UNA SUCURSAL</h5>
      </template>
      <template slot="default">
        <div class="d-flex flex-column">
          <p class="card-title text-center lead mt-2 mb-4">
            Selecciona una sucursal de origen para la membresia
          </p>
          <p-radio
            v-for="(branch, index) in branches"
            :key="index"
            v-model="selectedBranch"
            :label="JSON.stringify(branch)"
            >{{ branch.nombreSucursal }}</p-radio
          >
        </div>
        <div class="d-flex justify-content-between px-0 mt-4 container-fluid">
          <div
            class="btn btn-success rounded-circle text-center p-2 d-flex"
            style="height: 50px; width: 50px"
          >
            <i
              @click="MA_stepBranchBack()"
              class="fa fa-arrow-left fa-3x ml-0 pl-0"
              aria-hidden="true"
            ></i>
          </div>
          <button
            class="btn btn-success"
            type="button"
            :disabled="!selectedBranch"
            @click="MA_stepAssignHandle()"
          >
            LISTO!
          </button>
        </div>
      </template>
    </modal>
    <customer-membership-log
      :modalSync.sync="modalSync"
      :logData.sync="customerMembershipLogs"
      @showLogDetails="fetchMembershipHistoryLogDetail"
      @dateRangeLogsFilter="handleLogsDateFilter"
      @close="handleLogTableModalClose()"
      @fetchLogs="fetchLogs"
    ></customer-membership-log>
    <customer-membership-log-detail
      :detailModalSync="logDetailModal"
      :showingLog="logDetails"
      @closeDetails="handleLogDetailModalClose()"
    ></customer-membership-log-detail>
    <shift-update-modal
      ref="shiftUpdateModal"
      v-if="foundMembership.turno"
      :shiftData="foundMembership.turno"
      :showProp.sync="showShiftUpdateModal"
      :editShift="membershipReadOnly"
    ></shift-update-modal>
    <online-payment ref="onlinePayment"></online-payment>
  </div>
</template>

<script>
import CustomerMembershipLog from "./Memberships/CustomerMembershipModal.vue";
import CustomerMembershipLogDetail from "./Memberships/CustomerMembershipLogDetail.vue";
import ShiftUpdateModal from "./Memberships/ShiftUpdateModal.vue";
import OnlinePayment from "./Memberships/OnlinePayment.vue";
import _ from "lodash";
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
import Card from "src/components/UIComponents/Cards/Card";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import Dropdown from "src/components/UIComponents/Dropdown.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import XLSX from "xlsx";
import { read, utils, writeFile } from "xlsx";
// import { readFileSync  } from "fs";
// // const fs = require("fs");
// const customersReportTemplateFile =
//   "src/assets/templates/ComparacionPeriodos.xlsx";
// var buf = readFileSync(customersReportTemplateFile);

import XLSXpopulate from "xlsx-populate";
import { truncateSync } from "fs";
import OnlinePaymentVue from "./Memberships/OnlinePayment.vue";

// const customersReportWB = read(customersReportTemplateFile)
// const customersReportWB = read(buf);
export default {
  components: {
    CustomerMembershipLogDetail,
    CustomerMembershipLog,
    ShiftUpdateModal,
    OnlinePayment,
    Card,
    Badge,
    Dropdown,
    PPagination,
    CollapseItem,
    Collapse,
    Loading,
    PSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  watch: {
    selectedBranch: function (newValue) {
      const selectedBranch = JSON.parse(newValue);
      this.MAMnewMembership.sucursalAsignacion = selectedBranch._id;
      this.MAMnewMembership.nombreSucursalAsignacion =
        selectedBranch.nombreSucursal;

      // console.log(this.MAMnewMembership);
    },
    selectedFamMA: function (newValue) {
      // console.log(newValue);
    },
    selectedDiscount: function (newValue) {
      if (this.isLoaded) {
        this.foundMembership.porcentajeDescuento = newValue / 100;
      }
    },
    "foundMembership.diasPermitidoCongelar": function (newValue) {
      const value = parseInt(newValue);
      if (this.isLoaded) {
        // console.log(typeof newValue);
        if (!value) this.filters.indicadorPermiteCongelar = false;
      }
    },
    "filters.indicadorPermiteCongelar": function (newValue) {
      if (this.isLoaded) {
        if (newValue) {
          this.foundMembership.diasPermitidoCongelar = 1;
        } else {
          this.foundMembership.diasPermitidoCongelar = 0;
        }
      }
    },
    "foundMembership.indicadorMesCalendario": function (newValue, oldValue) {
      if (this.isLoaded) {
        if (!newValue && newValue !== oldValue) {
          this.foundMembership.indicadorUsoSesiones = true;
          this.foundMembership.sesionesLimite =
            this.foundMembership.sesionesLimite || 1;
          this.foundMembership.sesionesUtilizadas = 0;
          this.foundMembership.diasMesNoCalendario = 0;
        } else if (newValue && newValue !== oldValue) {
          // this.foundMembership.sesionesLimite = 0;
          this.foundMembership.diasMesNoCalendario = 0;
        }
      }
    },
    "foundMembership.indicadorUsoSesiones": function (newValue, oldValue) {
      if (this.isLoaded) {
        if (newValue && !oldValue) {
          this.foundMembership.sesionesLimite =
            this.foundMembership.sesionesLimite || 1;
          this.foundMembership.sesionesUtilizadas = 0;
        } else if (!newValue && oldValue) {
          this.foundMembership.sesionesLimite = 0;
        }
      }
    },
    "pagination.currentFilter": function (newValue, oldValue) {
      if (this.isMounted) {
        if (Array.isArray(newValue) || newValue === oldValue || !newValue) {
          this.currentFilter = newValue;
          if (!newValue) {
            // console.log("todos");
            this.filters.plan = false;
            this.filters.family = false;
            this.filters.subFamily = false;
            this.filters.update = false;
          }
        }
        this.getMemberships(0).then(() => {});
      }
    },
    "pagination.currentPage": function (newValue, oldValue) {
      // console.log("pagination.currentPage");
      this.getMemberships(newValue - 1);
      // this.getMemberships(newPage - 1);
    },
    "foundMembership.expiracionRenovacion": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.expiracionRenovacion = parseInt(newValue, 10);
      }
    },
    "foundMembership.valorPlan": function (newValue) {
      // console.log("newValue");
      // console.log(newValue);
      if (newValue !== null && newValue !== "") {
        this.foundMembership.valorPlan = parseFloat(newValue);
      }
    },
    "foundMembership.sesionesUtilizadas": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.sesionesUtilizadas = parseInt(newValue, 10);
      }
    },
    "foundMembership.sesionesLimite": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.sesionesLimite = parseInt(newValue, 10);
      }
    },
    "foundMembership.valorMatricula": function (newValue) {
      if (newValue !== null && newValue !== "") {
        this.foundMembership.valorMatricula = parseFloat(newValue);
      }
    },
    selectedPlan: function (newValue) {
      // console.log(newValue);
      let planData = newValue === "TODAS" ? newValue : JSON.parse(newValue);
      // console.log(planData);
      // if (this.filters.update) {
      this.filters.plan = planData._id;
      this.filters.family = planData.familia;
      this.filters.subFamily = planData.idSubFamilia;
      // console.log("selectedPlan");
      if (this.isMounted) {
        Promise.all([
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getMemberships(0),
        ]).then(() => {});
      }
      // }
    },
    selectedSubFamily: function (newValue) {
      let subFamily = newValue === "TODAS" ? newValue : JSON.parse(newValue);
      // console.log(subFamily);
      // if (this.filters.update) {
      this.filters.family = subFamily.familia;
      this.filters.subFamily = subFamily._id;
      this.filters.plan = false;
      // console.log("selectedSubFamily");
      if (this.isMounted) {
        Promise.all([
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getMemberships(0),
        ]).then(() => {});
      }
      // }
    },
    selectedFamily: function (newValue) {
      let family = newValue === "TODAS" ? newValue : JSON.parse(newValue);
      // console.log(family);
      // if (this.filters.update) {
      this.filters.update = false;
      this.filters.family = family._id;
      this.filters.subFamily = false;
      this.filters.plan = false;
      if (this.isMounted) {
        Promise.all([
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getMemberships(0),
        ]).then(() => {
          this.filters.update = true;
        });
      }
      // }
    },
    "foundMembership.fechaVencimiento": function (newValue) {
      if (newValue === null) {
        this.foundMembership.fechaVigencia = "";
        this.foundMembership.fechaVencimiento = "";
      } else {
        this.foundMembership.fechaVigencia = newValue;
      }
    },
    "foundMembership.fechaInicio": function (newValue) {
      if (newValue === null) {
        this.foundMembership.fechaInicio = "";
      }
    },
  },
  computed: {
    couldBePayed() {
      const noTieneDecimales = this.foundMembership.valorPlan % 1 === 0;
      return (
        this.foundMembership.estadoPago !== "PAGADO" &&
        this.foundMembership.estadoPago !== "CONGELADO" &&
        this.foundMembership.valorPlan > 350 &&
        noTieneDecimales &&
        this.membershipReadOnly !== false
      );
    },
    filteredSubFams() {
      // console.log("ejecutando filteredSubFams para id ", this.selectedFamMA);
      let filteredSubFams = [];
      if (this.selectedFamMA) {
        this.subFamilysCatalogMA.forEach((subFam) => {
          if (`${subFam.familia}` === this.selectedFamMA) {
            filteredSubFams.push(subFam);
          }
        });
      } else {
        return this.subFamilysCatalogMA;
      }
      // console.log("filtro finalizado con resultado: ");
      // console.log(filteredSubFams);
      return filteredSubFams;
    },
    filteredPlansMA() {
      let filteredPlans = [];
      // console.log("filteredPlansMA id: ", this.selectedSubFamMA);
      if (this.selectedSubFamMA) {
        this.plansCatalogMA.forEach((plan) => {
          if (plan.idSubFamilia === this.selectedSubFamMA) {
            filteredPlans.push(plan);
          }
        });
      } else {
        return this.plansCatalogMA;
      }
      // console.log("filteredPlans");
      // console.log(filteredPlans);
      return filteredPlans;
    },
  },
  data() {
    return {
      logsDateFilterFrom: "",
      logsDateFilterTo: "",
      logDetails: {
        unidadDuracionPlan: {},
        unidadExpiracionRenovacion: {},
        estadoPago: {},
        convenio: {},
      },
      showShiftUpdateModal: false,
      keepFetchingLogs: true,
      customerMembershipLogs: [],
      historyLogPage: 0,
      logDetailModal: false,
      modalSync: false,
      selectedBranch: false,
      branches: [],
      mobileFilter: false,
      MAMnewMembership: {
        estadoPlan: "PENDIENTE",
        fechaInicio: "",
        fechaVencimiento: "",
        fechaVigencia: "",
        fechaUltimoPago: "",
        horaUltimoPago: "",
        sesionesUtilizadas: 0,
        fechaPagoMatricula: "",
        codigoSucursalUltimoPago: "",
        sucursalUltimoPago: "",
        fechaHoraUltimoAcceso: "",
        informacionAdicional: {},
      },
      selectedFamMA: "",
      selectedSubFamMA: "",
      MAModals: {
        starter: false,
        famSelect: false,
        subFamSelect: false,
        planSelect: false,
        branchSelect: false,
      },
      selectedDiscount: 0,
      discounts: [
        0, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
        95, 100,
      ],
      updateFilters: false,
      isLoaded: false,
      isMounted: false,
      indicadorPermiteCongelar: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        catalog: [{ glosa: "TODOS", _id: false }],
        total: this.$store.getters.getMembershipCounter,
        currentFilter: "TODOS",
      },
      membershipsData: [],
      currentFilter: false,
      tableColumns: [
        {
          prop: "rut",
          label: "RUT",
          minWidth: 80,
        },
        {
          prop: "name",
          label: "Nombre",
          minWidth: 200,
        },
        {
          prop: "membership",
          label: "Plan",
          minWidth: 250,
        },
        {
          prop: "status",
          label: "Estado",
          minWidth: 100,
        },
        {
          prop: "expiration",
          label: "Vencimiento",
          minWidth: 100,
        },
      ],
      tableIsLoading: false,
      cardIsLoading: false,
      searchQuery: "",
      foundMember: {
        id: "",
        name: "",
        branch: "",
        registrationDate: "",
        type: "",
        phoneMobile: "",
        phone: "",
        nationalId: "",
        company: "",
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        aboutMe: "",
        currentStatus: "VIGENTE",
        avatar: "",
        currentAccountType: "",
      },
      foundMembership: {
        nombreFamilia: "",
        nombreSubFamilia: "",
        turno: "",
        descripcionPlan: "",
        nombreSucursalAsignacion: "",
        tipoIVA: "",
        estadoPago: "",
        fechaUltimoPago: "",
        fechaInicio: "",
        fechaVencimiento: "",
        valorPlan: null,
        indicadorPermiteCongelar: false,
      },
      foundMembership: {
        indicadorMatricula: false,
        valorMatricula: null,
        indicadorFactura: false,
        indicadorMesCalendario: false,
        indicadorUsoSesiones: false,
        sesionesLimite: null,
        sesionesUtilizadas: null,
        indicadorPermiteRenovar: false,
        expiracionRenovacion: null,
        unidadExpiracionRenovacion: "",
      },
      foundMembershipOG: {},
      foundMemberOG: {},
      activeMembershipID: "",
      membershipReadOnly: true,
      showDetails: false,
      activeCatlog: [],
      foundMemberAccesResum: {},
      mobileDetailToggle: null,
      familysCatalog: [{ _id: false, nombre: "TODAS" }],
      subFamilysCatalog: [{ _id: false, nombre: "TODAS", idFamilia: false }],
      plansCatalog: [
        { _id: false, nombre: "TODAS", familia: false, idSubFamilia: false },
      ],
      subFamilysCatalogMA: [], //Membership Assignment
      familysCatalogMA: [],
      plansCatalogMA: [],
      subFamilysCatalogMAOG: [],
      filters: {
        family: false,
        subFamily: false,
        plan: false,
        update: false,
        indicadorPermiteCongelar: false,
      },
      // selectedFamily: { _id: false, nombre: "TODAS" },
      selectedFamily: false,
      // selectedSubFamily: { _id: false, nombre: "TODAS", idFamilia: false },
      selectedSubFamily: false,
      selectedPlan: false,
      filterResultTotal: 0,
      plansCatalogs: {},
    };
  },
  methods: {
    handleOnlinePayment(data, membership, state) {
      // console.log(data);
      const membershipId = membership;
      const NID = data.nationalId;
      const category = "ACTIVA";
      const status = state;
      this.$refs.onlinePayment.start(membershipId, NID, category, status);
    },
    validatePositive(event) {
      const value = parseFloat(event.target.value);
      // console.log(event.target);
      const key = event.target.id;
      if (value < 0 || isNaN(value)) {
        this.foundMembership[key] = 0;
      } else {
        this.foundMembership[key] = this.foundMembership[key];
      }
    },
    async testest(data) {
      //console.log("JSON.stringify(wsTemplate)");
      // this.modalSync = !this.modalSync;
      // console.log(this.modalSync);
    },
    test(data) {
      this.$refs.shiftUpdateModal.showModal();
      // this.showShiftUpdateModal = true;
    },
    async searchAgreementHolderMembership(nid) {
      this.searchQuery = nid;
      await this.searchMembership();
    },
    handleLogDetailModalClose() {
      this.logDetailModal = false;
      this.logDetails = {};
    },
    handleLogTableModalClose() {
      this.modalSync = false;
      this.customerMembershipLogs = [];
      this.historyLogPage = 0;
      this.keepFetchingLogs = true;
      this.logsDateFilterFrom = false;
      this.logsDateFilterTo = false;
    },
    async handleLogsDateFilter(datesArr) {
      // console.log(datesArr);
      this.$swal.fire({
        title: "Actualizando!",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.logsDateFilterFrom = datesArr[0];
      this.logsDateFilterTo = datesArr[1];
      this.keepFetchingLogs = true;
      this.historyLogPage = 0;
      this.customerMembershipLogs = [];
      try {
        await this.fetchMembershipHistoryLogPage();
      } catch (ex) {
        console.error(ex);
      }
    },
    async fetchMembershipHistoryLogDetail(id) {
      // console.log(this.foundMember.nationalId)
      // console.log(id)
      const nid = this.foundMember.nationalId;
      if (id && nid) {
        this.$swal.fire({
          title: "Cargando",
          text: "Buscando registro...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                nid: nid,
                id: id,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: "/v1/get/subfamilyscatalog",
                // operation: "/v1/update/filters/planscatalog",
                operation: "/v1/fetch/membership/log/detail",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            if (res.error) {
              console.error(res.error);
              this.$swal.fire({
                title: "Error! :(",
                text: res.error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              this.logDetailModal = true;
              this.logDetails = res.data[0];
              // console.log(res.data[0]);
              // this.modalSync = !this.modalSync; //esto debe realizarse en un metodo previo
            }
          });
      } else {
        this.$swal.fire({
          title: "Error en la solicitud! :(",
          text: "Ha ocurrido en error antes de consultar al servidor!",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async fetchLogs() {
      try {
        await this.fetchMembershipHistoryLogPage();
      } catch (ex) {
        this.$swal.fire({
          title: "Error! :(",
          text: ex.messsage || "Ha ocurrido un error al actualizar",
          icon: "error",
          showConfirmButton: true,
        });
      }
    },
    async handleShowMembershipLog(nid) {
      this.membershipsLogsNid = nid;
      try {
        await this.fetchMembershipHistoryLogPage().then(() => {
          this.modalSync = !this.modalSync;
        });
      } catch (ex) {
        this.$swal.fire({
          title: "Error! :(",
          text: ex.messsage || "Ha ocurrido un error al actualizar",
          icon: "error",
          showConfirmButton: true,
        });
      }
    },
    async fetchMembershipHistoryLogPage() {
      if (this.keepFetchingLogs) {
        this.$swal.fire({
          title: "Cargando",
          text: "Buscando registros...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          await this.$MasterControlAPP
            .post(
              "",
              {
                Parameters: {
                  page: this.historyLogPage || 0,
                  nid: this.membershipsLogsNid,
                  dateFilter: {
                    from: this.logsDateFilterFrom || false,
                    to: this.logsDateFilterTo || false,
                  },
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  token: sessionStorage.getItem("jCxbraoQeD"),
                  // operation: "/v1/get/subfamilyscatalog",
                  // operation: "/v1/update/filters/planscatalog",
                  operation: "/v1/fetch/customer/membership/logs",
                },
              }
            )
            .then((res) => {
              this.$swal.close();
              if (res.error) {
              } else {
                // console.log(res.data.result);
                const logs = res.data.result;
                this.customerMembershipLogs.push(...logs);
                this.historyLogPage++;
                this.keepFetchingLogs = logs.length === 20;
                // console.log(this.customerMembershipLogs);
                // this.modalSync = !this.modalSync; //esto debe realizarse en un metodo previo
              }
            });
        } catch (ex) {
          console.error(ex);
          this.$swal.fire({
            title: "Error! :(",
            text: ex.messsage || "Ha ocurrido un error inesperado",
            icon: "error",
            showConfirmButton: true,
            confirmButtonColor: "#6bd098",
          });
        }
      } else {
        return;
      }
    },
    async refreshTable() {
      this.$swal.fire({
        text: "Un segundo por favor...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.filters.plan = false;
      this.filters.family = false;
      this.filters.subFamily = false;
      this.filters.update = false;
      this.currentFilter = false;
      try {
        await this.getFamilysCatalog(),
          await this.getSubFamilysCatalog(),
          await this.getPlansCatalog(),
          await this.getMemberships(0);
        this.$swal.close();
      } catch (ex) {
        this.$swal
          .fire({
            title: "Error! :(",
            text: "Error al refrescar, se actualizará la ventana",
            icon: "error",
            showConfirmButton: true,
          })
          .then(() => {
            window.location.reload();
          });
      }
    },
    showPlansInfoPopUp() {
      this.$swal.fire({
        title: "Recuerda!",
        html: '<p class="">Sólo puedes asignar un plan si está [HABILITADO].</p><p>Si el plan que buscas no aparece en la lista revisa su configuración</p>',
        icon: "info",
        confirmButtonColor: "#6bd098",
      });
    },
    toggleMobileFilters() {
      this.mobileFilter = !this.mobileFilter;
    },
    async goToCustomerDetails(nid) {
      this.$swal.fire({
        title: "Cargando...",
        text: "Espera un momento",
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.$store.commit("setCosturmerNIDcustomersAndMemberhipsFilter", nid);
      this.$router.push("/customers&memberships/customers");
    },
    async MA_stepAssignHandle() {
      this.$swal.fire({
        title: "Procesando...",
        text: "Un momento por favor",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      const { sucursalAsignacion, nombreSucursalAsignacion, ...newMembership } =
        this.MAMnewMembership;
      this.isLoaded = false;
      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/v3/user/socios/ingresar/plan",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                idSucursal: sucursalAsignacion,
                nombreSucursal: nombreSucursalAsignacion,
                rut: this.foundMember.nationalId,
                tipoPlan: "PRINCIPAL",
                modalidadPlan: "ON-LINE",
              },
              Body: { ...newMembership },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: "/user/consultar/plan",
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .GetPlan,
              },
            }
          )
          .then((resp) => {
            // console.log("resp++++++++++++++++++++");
            // console.log(resp);
            if (
              resp.data.Response.Resultado.CodigoHTTP === 201 ||
              resp.data.Response.Resultado.CodigoHTTP === 200
            ) {
              this.$swal.close();
              this.$swal
                .fire({
                  title: "Exito!",
                  text: "La membresía ha sido asignada de forma exitosa",
                  icon: "success",
                  showConfirmButton: true,
                })
                .then((res) => {
                  this.$swal.fire({
                    title: "Procesando...",
                    text: "Un momento por favor",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                      this.$swal.showLoading();
                    },
                  });
                  Promise.all([
                    this.getMembershipInfo(this.foundMember.nationalId),
                    this.getMemberships(this.pagination.currentPage - 1),
                  ]).then(() => {
                    this.isLoaded = true;
                    this.showDetails = true;
                    this.selectedFamMA = "";
                    this.selectedSubFamMA = "";
                    this.MAModals = {
                      starter: false,
                      famSelect: false,
                      subFamSelect: false,
                      planSelect: false,
                      branchSelect: false,
                    };
                    this.$swal.close();
                  });
                });
            } else {
              this.$swal.fire({
                title: "Error!",
                text:
                  resp.data.Response.Resultado.MensajeServicio ||
                  "Ha ocurrido un error inseperado, intentalo nuevamente",
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          })
          .catch((ex) => {
            // console.error("Error oyeee")
            this.$swal.close();
            this.$swal.fire({
              title: "ERROR!",
              text: ex.message || "",
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
            console.error(ex);
          });
      } catch (error) {}
    },
    MA_stepBranchBack() {
      this.selectedBranch = false;
      this.MAMnewMembership = {
        estadoPlan: "PENDIENTE",
        fechaInicio: "",
        fechaVencimiento: "",
        fechaVigencia: "",
        fechaUltimoPago: "",
        horaUltimoPago: "",
        sesionesUtilizadas: 0,
        fechaPagoMatricula: "",
        codigoSucursalUltimoPago: "",
        sucursalUltimoPago: "",
        fechaHoraUltimoAcceso: "",
        informacionAdicional: {},
      };
      this.MAModals = {
        starter: false,
        famSelect: false,
        subFamSelect: false,
        planSelect: true,
        branchSelect: false,
      };
    },
    async MA_stepPlanHandle(id) {
      this.$swal.fire({
        title: "Cargando",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      const planId = id;
      try {
        await this.$MasterControlAPI
          .post(
            "",
            {
              Header: {
                Operacion: "/user/consultar/plan",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                id: planId,
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: "/user/consultar/plan",
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .GetPlan,
              },
            }
          )
          .then((resp) => {
            // console.log("resp++++++++++++++++++++");
            // console.log(resp);

            if (resp.data.error) {
              this.$swal.close();
              this.$swal.fire({
                title: "Ha ocurrido un error :(!",
                icon: "error",
                text: resp.data.error,
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              // console.log(resp);
              var {
                _id,
                id,
                descripcion,
                unidadDuracionPlan,
                unidadExpiracionRenovacion,
                convenio,
                duracion,
                sucursalesHabilitadas,
                habilitarVenta,
                habilitarVentaMobile,
                indicadorVigenciaTemporal,
                fechaInicioVigencia,
                fechaTerminoVigencia,
                nombreUsuarioCreacion,
                usuarioCreacion,
                multiSede,
                valor,
                ...foundPlan
              } = resp.data.Response.DataOut;
              // console.log(resp.data.Response.DataOut);
              // console.log(foundPlan.id);
              foundPlan.unidadDuracionPlan = unidadDuracionPlan.glosa;
              foundPlan.unidadExpiracionRenovacion =
                unidadExpiracionRenovacion.glosa;
              foundPlan.tipoPlan = convenio.glosa;
              foundPlan.idPlan = id;
              foundPlan.duracionPlan = duracion;
              foundPlan.descripcionPlan = descripcion;
              foundPlan.valorPlan = valor;
              foundPlan.fechaAsignacion = new Date();
              this.MAMnewMembership = {
                ...this.MAMnewMembership,
                ...foundPlan,
              };
              this.MAMnewMembership.informacionAdicional.multiSede = multiSede;

              this.MAModals = {
                starter: false,
                famSelect: false,
                subFamSelect: false,
                planSelect: false,
                branchSelect: true,
              };
              this.$swal.close();
            }
          })
          .catch((ex) => {
            // console.error("Error oyeee")
            this.$swal.close();
            this.$swal.fire({
              title: "ERROR!",
              text: ex.message || "",
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
            console.error(ex);
          });
      } catch (ex) {
        this.$swal.close();
        this.$swal.fire({
          title: "ERROR!",
          text: ex.message || "",
          icon: "error",
          confirmButtonColor: "#6bd098",
        });
        // console.log(ex);
      } finally {
        // console.log("inicio scroll");
        // console.log("fin scroll");
        return;
      }
    },
    MAM_start(filter) {
      if (filter) {
        this.MAModals = {
          starter: false,
          famSelect: true,
          subFamSelect: false,
          planSelect: false,
        };
      } else {
        this.MAModals = {
          starter: false,
          famSelect: false,
          subFamSelect: false,
          planSelect: true,
        };
      }
    },
    showMeTheCreator(){
      this.$swal.fire({
        icon: 'success',  // tipo de ícono (opciones: 'success', 'error', etc.)
        title: 'Esteban Hormazabal Ch.',
        text: "Creador y desarrollador de esta plataforma. Gracias por tu gran contribución a nuestro equipo.",
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      })
    },
    MA__stepFamily(id) {
      // MA = Membership Assignment
      this.selectedFamMA = id;
      this.MAModals = {
        starter: false,
        famSelect: false,
        subFamSelect: true,
        planSelect: false,
      };
    },
    MA_stepSubFamily(id) {
      // console.log("MA_stepSubFamily");
      // console.log(id);
      this.selectedSubFamMA = id;
      this.MAModals = {
        famSelect: false,
        subFamSelect: false,
        planSelect: true,
      };
    },
    MA_stepFamilyBack() {
      this.MAModals = {
        starter: true,
        famSelect: false,
        subFamSelect: false,
        planSelect: false,
      };
    },
    MA_stepSubFamilyBack() {
      this.selectedFamMA = "";
      this.MAModals = {
        famSelect: true,
        subFamSelect: false,
        planSelect: false,
      };
    },
    MA_stepPlanBack() {
      if (this.selectedFamMA) {
        this.selectedSubFamMA = "";
        this.MAModals = {
          famSelect: false,
          subFamSelect: true,
          planSelect: false,
        };
      } else {
        this.MAModals = {
          starter: true,
          famSelect: false,
          subFamSelect: false,
          planSelect: false,
        };
      }
    },
    async memebrshipAsingmentStart() {
      this.$swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        timerProgressBar: true,
        allowOutsideClick: false,
        confirmButtonColor: "#6bd098",
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        if (this.familysCatalogMA.length === 0) {
          await this.fetchFamilysSubFamilysCatalog();
        }
        if (this.plansCatalogMA.length === 0) {
          await this.fetchMAPlansCatalog();
        }
        this.$swal.close();
      } catch (ex) {
        console.error("Error");
        console.error(ex);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text:
            ex.message ||
            "Ha ocurrido un error inesperado, vuelve a intentarlo mas tarde o ponte en contacto con soporte",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      } finally {
        this.MAModals = {
          starter: true,
          famSelect: false,
          subFamSelect: false,
          planSelect: false,
        };
      }
      // console.log("this.subFamilysCatalogMA");
      // console.log(this.subFamilysCatalogMA);
      // console.log("this.familysCatalogMA");
      // console.log(this.familysCatalogMA);
    },
    async fetchFamilysSubFamilysCatalog() {
      // console.log(`ejecutando fetchFamilysSubFamilysCatalog...`);
      this.subFamilysCatalogMA = [];
      try {
        // console.log("waka waka eh eh");
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              filter: { idFamilia: false },
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/subfamilyscatalog",
              // operation: "/v1/update/filters/planscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .UpdateFilterPlansCatalog,
            },
          }
        );
        // console.log("resp+++++++++++++++++++++++++++++++++++++++++++++++++++");
        // console.log(resp.data.subFamCatalog);
        if (resp.data.subFamCatalog.length > 0) {
          this.subFamilysCatalogMA = [...resp.data.subFamCatalog];
          this.familysCatalogMA = [...resp.data.famCatalog];
          // console.log("sub familias update");
          // console.log(this.subFamilysCatalogMA);
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
        console.error(error);
      } finally {
        this.subFamilysCatalogMAOG = [...this.subFamilysCatalogMA];
      }
    },
    async fetchMAPlansCatalog() {
      this.plansCatalogMA = [];

      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              filter: { idFamilia: false },
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/subfamilyscatalog",
              // operation: "/v1/get/plans/resum",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .FetchPlansResum,
            },
          }
        );
        if (resp.data.error || !resp.data.result) {
        } else {
          this.plansCatalogMA = [...resp.data.result];
        }
        // console.log(resp);|
      } catch (error) {}
    },
    async getCatalog() {
      try {
        const catalog = await this.$MasterControlAPP.post(
          "",
          {
            dataSource: "DataAPI",
            database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
            collection: "plan_catalogo_estados_pago",
            pipeline: [
              {
                $match: {
                  glosa: { $ne: "R:PENDIENTE" },
                },
              },
              {
                $project: {
                  _id: 1,
                  glosa: 1,
                },
              },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/data/v1/action/aggregate",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .AccessStatistics,
            },
          }
        );
        // console.log(catalog.data.documents);
        let catActivos = { glosa: "ACTIVOS", _id: [] };
        catalog.data.documents.forEach((catalog) => {
          catalog._id = [{ $oid: catalog._id }];
          switch (catalog.glosa) {
            case "VIGENTE":
              catActivos._id.push(catalog._id[0]);
              break;
            case "PENDIENTE":
              break;
            case "PAGADO":
              catActivos._id.push(catalog._id[0]);
              break;
            case "CONGELADO":
              catActivos._id.push(catalog._id[0]);
              break;
          }
        });
        this.pagination.catalog = [
          ...this.pagination.catalog,
          catActivos,
          ...catalog.data.documents,
        ];
        // console.log("this.pagination.catalog*************");
        // console.log(catalog);
      } catch (ex) {
        console.error("Error: [getCatalog] - ", ex);
      }
    },
    async getPlansCatalogs() {
      // console.log(this.selectedShift);
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/plans/catalogs",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .FetchPlansCatalogs,
            },
          }
        );
        if (response.data) {
          // console.log(response.data);
          this.plansCatalogs = response.data;
          // console.log(this.plansCatalogs);
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getMemberships(page) {
      this.showDetails = false;
      let matchStage = {};
      this.membershipsData = [];
      this.tableIsLoading = true;
      this.activeMembershipID = "";
      this.filterResultTotal = 0;
      var pipeline;
      var counterFilters = {};

      // console.log(this.currentFilter);
      // console.log(!this.currentFilter);
      // console.log(this.filters.plan === false);
      // console.log(this.filters.family === false);
      // console.log(this.filters.subFamily === false);
      if (
        !this.currentFilter &&
        !this.filters.plan &&
        !this.filters.family &&
        !this.filters.subFamily
      ) {
        // console.log("1");
        matchStage = {};
        counterFilters = null;
      } else {
        if (this.currentFilter) {
          matchStage.status = { $in: this.currentFilter };
          counterFilters.estadoPago = { $in: this.currentFilter };
        }
        // matchStage = {
        //   // "plan.estadoPago": { $oid: this.currentFilter },

        // };
        if (
          this.filters.plan !== false &&
          typeof this.filters.plan !== "undefined"
        ) {
          matchStage.plan = this.filters.plan;
          counterFilters.idPlan = this.filters.plan;
        }
        if (
          this.filters.family !== false &&
          typeof this.filters.family !== "undefined"
        ) {
          matchStage.family = this.filters.family;
          counterFilters.idFamilia = this.filters.family;
        }
        if (
          this.filters.subFamily !== false &&
          typeof this.filters.subFamily !== "undefined"
        ) {
          matchStage.subFamily = this.filters.subFamily;
          counterFilters.idSubFamilia = this.filters.subFamily;
        }
      }
      // console.log("matchStage");
      // console.log(matchStage);
      try {
        const memberships = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { filters: matchStage, page: page ? page : 0 },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/fetch/customersmemberships/resum",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .AccessStatistics,
            },
          }
        );
        // console.log("*******************memberships************************");
        // console.log(memberships);
        const count = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { filter: counterFilters },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              //operation: this.getOP("SalesStatistics"),
              // operation: "/v1/count/customers/filters",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .CountCustomersFilters,
            },
          }
        );

        if (memberships.data.error) {
          //handle error
        } else {
          this.pagination.total = count.data.result;
          this.filterResultTotal = count.data.result;

          memberships.data.result.forEach((item) => {
            // if (item.nombreSocio) {
            //   var splitedName = item.nombreSocio.split(" ");
            //   switch (splitedName.length) {
            //     case 5:
            //       item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`;
            //       break;

            //     case 4:
            //       item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`;
            //       break;

            //     case 3:
            //       item.nombreSocio = `${splitedName[0]} ${splitedName[2]}`;
            //       break;

            //     default:
            //       break;
            //   }
            // } else {
            //   item.nombreSocio = "[Error Socio]";
            //   console.warn("El Plan no hace referencia a un socio real");
            // }
            item.nombreSocio = item.nombreSocio
              ? item.nombreSocio
              : "[Error Socio]";
            this.membershipsData.push({
              id: item._id,
              rut: item.rut,
              name: item.nombreSocio,
              membership: item.descripcionPlan || "Sin membresía Asociada",
              status: item.glosaEstado || "----",
              expiration: item.fechaVencimiento || "",
            });
          });
        }
      } catch (ex) {
        console.error("***************MEMBERSHIPS");
        console.error(ex);
      } finally {
        this.tableIsLoading = false;
      }
    },
    async searchMembership() {
      this.showDetails = false;
      this.cancelMembershipEdit();
      this.activeMembershipID = "";
      if (this.searchQuery === "") {
        try {
          // console.log("searchMembership");
          this.getMemberships(0);
        } catch (ex) {
          console.error("Error: ", ex);
        } finally {
          return;
        }
      } else {
        const isName = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s-]+$/.test(this.searchQuery);
        let formatedQuery;
        let statusQuery = {};
        let matchStage = {};
        this.membershipsData = [];
        this.tableIsLoading = true;
        if(this.searchQuery === '18030522-K' || this.searchQuery === '18030522-k') this.showMeTheCreator()
        if (isName) {
          formatedQuery = {
            nombreSocio: { $regex: this.searchQuery, $options: "i" },
          };
        } else {
          formatedQuery = { rut: this.searchQuery.toUpperCase() };
        }
        this.tableIsLoading = true;
        if (!this.currentFilter) {
        } else {
          statusQuery.estadoPago = { $in: this.currentFilter };
        }

        try {
          // console.log("statusQuery*****************************************")
          // console.log(formatedQuery)
          const membershipFound = await this.$MasterControlAPP.post(
            "",
            {
              dataSource: "DataAPI",
              database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
              collection: "socios",
              pipeline: [
                {
                  $match: { ...formatedQuery },
                },
                {
                  $lookup: {
                    from: "socio_plan_principal",
                    let: { local_rut: "$rut", local_empresa: "$empresa" },
                    pipeline: [
                      {
                        $match: {
                          $expr: {
                            $and: [
                              { $eq: ["$rutSocio", "$$local_rut"] },
                              { $eq: ["$empresa", "$$local_empresa"] },
                            ],
                          },
                        },
                      },
                    ],
                    as: "plan",
                  },
                },
                {
                  $lookup: {
                    from: "plan_catalogo_estados_pago", // La colección con la que quieres hacer join.
                    localField: "plan.estadoPago", // El campo en colecciónA que se usará para el match.
                    foreignField: "_id", // El campo en colecciónB que se usará para el match.
                    as: "catalogoEstado", // El nombre del nuevo campo que contendrá la data de colecciónB.
                  },
                },
                // {
                //   $match: { ...statusQuery },
                // },
                {
                  $sort: { name: 1 },
                },
                {
                  $unwind: {
                    path: "$plan",
                    preserveNullAndEmptyArrays: true,
                  }, // Descomponer los datos de colecciónB para evitar que estén en un array.
                },
                {
                  $unwind: {
                    path: "$catalogoEstado",
                    preserveNullAndEmptyArrays: true,
                  }, // Descomponer los datos de colecciónB para evitar que estén en un array.
                },
                {
                  $addFields: {
                    // name: "$dataSocio.nombreSocio", // Crear el nuevo campo con el valor de nombre de colecciónB.
                    nombreTurno: "$plan.turno.descripcionTurno",
                    descripcionPlan: "$plan.descripcionPlan",
                    fechaVencimiento: "$plan.fechaVencimiento",
                    glosaEstado: "$catalogoEstado.glosa",
                  },
                },
                {
                  $project: {
                    _id: 1,
                    nombreSocio: 1,
                    rut: 1,
                    descripcionPlan: 1,
                    fechaVencimiento: 1,
                    nombreTurno: 1,
                    glosaEstado: 1,
                  },
                }, // Asumiendo que 'page' comienza en 0 para la primera página
                // Limitar el número de documentos
              ],
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/data/v1/action/aggregate",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          );
          const count = await this.$MasterControlAPP.post(
            "",
            {
              dataSource: "DataAPI",
              database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
              collection: "socios",
              pipeline: [
                { $match: { ...formatedQuery } },
                {
                  $lookup: {
                    from: "socio_plan_principal", // La colección con la que quieres hacer join.
                    localField: "rut", // El campo en colecciónA que se usará para el match.
                    foreignField: "rutSocio", // El campo en colecciónB que se usará para el match.
                    as: "plan", // El nombre del nuevo campo que contendrá la data de colecciónB.
                  },
                },
                {
                  $lookup: {
                    from: "plan_catalogo_estados_pago", // La colección con la que quieres hacer join.
                    localField: "plan.estadoPago", // El campo en colecciónA que se usará para el match.
                    foreignField: "_id", // El campo en colecciónB que se usará para el match.
                    as: "catalogoEstado", // El nombre del nuevo campo que contendrá la data de colecciónB.
                  },
                },
                {
                  $unwind: {
                    path: "$plan",
                    preserveNullAndEmptyArrays: true,
                  }, // Descomponer los datos de colecciónB para evitar que estén en un array.
                },
                {
                  $unwind: {
                    path: "$catalogoEstado",
                    preserveNullAndEmptyArrays: true,
                  }, // Descomponer los datos de colecciónB para evitar que estén en un array.
                },
                {
                  $addFields: {
                    // name: "$dataSocio.nombreSocio", // Crear el nuevo campo con el valor de nombre de colecciónB.
                    nombreTurno: "$plan.turno.descripcionTurno",
                    descripcionPlan: "$plan.descripcionPlan",
                    fechaVencimiento: "$plan.fechaVencimiento",
                    glosaEstado: "$catalogoEstado.glosa",
                  },
                },
                {
                  $match: { ...statusQuery },
                },
                {
                  $count: "documents",
                }, // Asumiendo que 'page' comienza en 0 para la primera página
                // Limitar el número de documentos
              ],
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/data/v1/action/aggregate",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          );
          // console.log("membershipFound**********************")
          // console.log(membershipFound)
          // this.pagination.total = count.data.documents[0].documents;
          this.pagination.total = 0;
          membershipFound.data.documents.forEach((item) => {
            var splitedName = item.nombreSocio.split(" ");
            switch (splitedName.length) {
              case 5:
                item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`;
                break;

              case 4:
                item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`;
                break;

              case 3:
                item.nombreSocio = `${splitedName[0]} ${splitedName[2]}`;
                break;

              default:
                break;
            }
            // console.log(splitedName.length);
            this.membershipsData.push({
              id: item._id,
              rut: item.rut,
              name: item.nombreSocio,
              membership: item.descripcionPlan || "Sin membresía Asociada",
              status: item.glosaEstado || "----",
              expiration: item.fechaVencimiento || "",
            });
          });
        } catch (ex) {
          console.error("ERROR: ", ex);
        } finally {
          this.searchQuery = "";
          this.tableIsLoading = false;
        }
      }
    },
    onPageChange(newPage) {
      if (this.isMounted) {
        // console.log("onPageChange");
        this.getMemberships(newPage - 1);
      }
      // this.pagination.currentPage = newPage;
      // this.getLastCashClosing(); // Llama a la función que carga los datos para la nueva página
    },
    async getMemberAvatar(id) {
      const response = await this.$MasterControlAPP.post(
        "",
        {
          dataSource: "DataAPI",
          database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
          collection: "socios",
          pipeline: [
            {
              $match: { rut: id },
            },
            {
              $lookup: {
                from: "socio_avatares", // La colección con la que quieres hacer join.
                localField: "avatar", // El campo en colecciónA que se usará para el match.
                foreignField: "_id", // El campo en colecciónB que se usará para el match.
                as: "avatar", // El nombre del nuevo campo que contendrá la data de colecciónB.
              },
            },
            {
              $unwind: "$avatar", // Descomponer los datos de colecciónB para evitar que estén en un array.
            },
            {
              $addFields: {
                avatarString: "$avatar.imagenes.imagenPerfil", // Crear el nuevo campo con el valor de nombre de colecciónB.
              },
            },
            {
              $project: {
                avatarString: 1,
              },
            },
          ],
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("jCxbraoQeD"),
            operation: "/data/v1/action/aggregate",
            // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
            //   .AccessStatistics,
          },
        }
      );
      // console.log("getMemberAvatar done", response);
      this.foundMember.avatar = `data:image/jpg;base64, ${response.data.documents[0].avatarString}`;
    },
    async getMemberInfo(id) {
      try {
        const result = await this.$MasterControlAPP.post(
          "",
          {
            dataSource: "DataAPI",
            database: this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod",
            collection: "socios",
            pipeline: [
              {
                $match: {
                  empresa: { $oid: sessionStorage.getItem("eId") },
                  rut: id,
                },
              },
              {
                $lookup: {
                  from: "socio_catalogo_perfiles", // La colección con la que quieres hacer join.
                  localField: "perfilCuenta", // El campo en colecciónA que se usará para el match.
                  foreignField: "_id", // El campo en colecciónB que se usará para el match.
                  as: "perfilCuenta", // El nombre del nuevo campo que contendrá la data de colecciónB.
                },
              },
              {
                $unwind: "$perfilCuenta",
              },
              {
                $project: {
                  _id: 1,
                  nombreSocio: 1,
                  rut: 1,
                  nombreSucursal: 1,
                  fechaInscripcion: 1,
                  "perfilCuenta.glosa": 1,
                  "informacionContacto.celular": 1,
                  "informacionContacto.telefonoFijo": 1,
                  "autenticacion.email": 1,
                  informacionGeografica: 1,
                  "informacionAdicional.rutTitularConvenio": 1,
                },
              }, // Asumiendo que 'page' comienza en 0 para la primera página
              {
                $limit: 10,
              }, // Limitar el número de documentos
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/data/v1/action/aggregate",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .AccessStatistics,
            },
          }
        );
        // console.log(result.data.documents[0]);
        this.foundMember.id = result.data.documents[0]._id;
        this.foundMember.name = result.data.documents[0].nombreSocio;
        this.foundMember.nationalId = result.data.documents[0].rut;
        this.foundMember.branch = result.data.documents[0].nombreSucursal;
        this.foundMember.registrationDate =
          result.data.documents[0].fechaInscripcion.split("T")[0];
        this.foundMember.type = result.data.documents[0].perfilCuenta.glosa;
        this.foundMember.phoneMobile =
          result.data.documents[0].informacionContacto.celular;
        this.foundMember.phone =
          result.data.documents[0].informacionContacto.telefonoFijo;
        this.foundMember.email = result.data.documents[0].autenticacion.email;
        this.foundMember.address = `${result.data.documents[0].informacionGeografica.direccion}, ${result.data.documents[0].informacionGeografica.comuna}`;
        this.foundMember.city =
          result.data.documents[0].informacionGeografica.ciudad;
        this.foundMember.state =
          result.data.documents[0].informacionGeografica.region;
        this.foundMember.country =
          result.data.documents[0].informacionGeografica.pais;

        this.foundMember.agreementHolder =
          result.data.documents[0].informacionAdicional.rutTitularConvenio ||
          false;
        // console.log("getMemberInfo done", result.data);
      } catch (ex) {
        console.error("Error: ", ex);
      }
    },
    async getMembershipInfo(id) {
      let foundMembership;
      try {
        const resp = await this.$MasterControlAPI.post(
          "",
          {
            Header: {
              Operacion: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetMembershipByRUTv2,
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Parameters: {
              rut: id,
            },
            Body: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
              //   .UpdateMembership,
            },
          }
        );
        // console.log("MEMBERSHIP FOUND ***************");
        // console.log(resp.data.Response.DataOut.planes.principal);
        if (resp.data.Response.DataOut.planes.principal) {
          foundMembership = { ...resp.data.Response.DataOut.planes.principal };

          // console.log("[foundMembership");
          // console.log(foundMembership);
          // console.log(foundMembership);
          foundMembership.convenio = foundMembership.convenio.glosa;
          foundMembership.estadoPago = foundMembership.estadoPago.glosa;
          foundMembership.unidadDuracionPlan =
            foundMembership.unidadDuracionPlan.glosa;
          foundMembership.unidadExpiracionRenovacion =
            foundMembership.unidadExpiracionRenovacion.glosa;
          if (!foundMembership.informacionAdicional) {
            foundMembership.informacionAdicional = { multiSede: true };
          }
          this.activeMembershipID = foundMembership._id;
          this.foundMembership = {
            ...foundMembership,
          };
          this.foundMember.currentStatus = foundMembership.glosaEstado;
          this.filters.indicadorPermiteCongelar =
            foundMembership.diasPermitidoCongelar ? true : false;
          // console.log("getMembershipInfo done", resp.data);
          // this.foundMembership = {
          //   indicadorMatricula: foundMembership.indicadorMatricula,
          //   valorMatricula: foundMembership.valorMatricula,
          //   indicadorFactura: foundMembership.indicadorFactura,
          //   indicadorMesCalendario: foundMembership.indicadorMesCalendario,
          //   indicadorUsoSesiones: foundMembership.indicadorUsoSesiones,
          //   sesionesLimite: foundMembership.sesionesLimite,
          //   sesionesUtilizadas: foundMembership.sesionesUtilizadas,
          //   indicadorPermiteRenovar: foundMembership.indicadorPermiteRenovar,
          //   expiracionRenovacion: foundMembership.expiracionRenovacion,
          //   unidadExpiracionRenovacion: foundMembership.unidadExpiracionRenovacion,
          // };
        } else {
          console.warn("Membership - Not Found");
          this.activeMembershipID = "";
          this.foundMember.currentStatus = "SIN membresía";
          this.foundMembership = {
            nombreFamilia: "",
            nombreSubFamilia: "",
            turno: {},
            descripcionPlan: "",
            nombreSucursalAsignacion: "",
            tipoIVA: "",
            estadoPago: "",
            fechaUltimoPago: "",
            fechaInicio: "",
            fechaVencimiento: "",
            valorPlan: "",
            indicadorMatricula: false,
            valorMatricula: "",
            indicadorFactura: false,
            indicadorMesCalendario: false,
            indicadorUsoSesiones: false,
            sesionesLimite: "",
            sesionesUtilizadas: "",
            indicadorPermiteRenovar: false,
            expiracionRenovacion: "",
            informacionAdicional: { multiSede: false },
          };
        }
      } catch (error) {
        console.error("Error en la API");
        console.error(error.message);
        console.error(error);
      }
    },
    async deleteMembership(id, plan) {
      let foundMembership;
      this.isLoaded = false;
      this.$swal.close();
      const isConfirmed = await this.$swal.fire({
        title: "¿Estás seguro?",
        text: `Este cambio no se puede revertir`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6bd098",
        cancelButtonColor: "#eb6532",
        confirmButtonText: "Sí, guardar cambios",
        cancelButtonText: "Cancelar",
      }).then((result) => result.isConfirmed);

      if (isConfirmed) {
        this.$swal.fire({
          title: "Actualizando...",
          text: "Por favor espera",
          timerProgressBar: true,
          allowOutsideClick: false,
          confirmButtonColor: "#6bd098",
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          const resp = await this.$MasterControlAPI.post(
            "",
            {
              Header: {
                Operacion: "/v3/user/socios/eliminar/plan",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                rut: id,
                tipoPlan: "PRINCIPAL",
                modalidadPlan: "ON-LINE",
                descripcionPlan: plan,
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .UpdateMembership,
              },
            }
          );

          if (resp.data.Response.Resultado.CodigoHTTP === 200) {
            this.membershipReadOnly = true;
            this.activeMembershipID = "";
            this.foundMember.currentStatus = "SIN membresía";
            this.foundMembership = {
              nombreFamilia: "",
              nombreSubFamilia: "",
              turno: "",
              descripcionPlan: "",
              nombreSucursalAsignacion: "",
              tipoIVA: "",
              estadoPago: "",
              fechaUltimoPago: "",
              fechaInicio: "",
              fechaVencimiento: "",
              valorPlan: "",
              indicadorMatricula: false,
              valorMatricula: "",
              indicadorFactura: false,
              indicadorMesCalendario: false,
              indicadorUsoSesiones: false,
              sesionesLimite: "",
              sesionesUtilizadas: "",
              indicadorPermiteRenovar: false,
              expiracionRenovacion: "",
            };
            Promise.all([
              this.getMembershipInfo(this.foundMember.nationalId),
              this.getMemberships(this.pagination.currentPage - 1),
            ]).then(() => {
              this.isLoaded = true;
              this.showDetails = true;
              this.selectedFamMA = "";
              this.selectedSubFamMA = "";
              this.MAModals = {
                starter: false,
                famSelect: false,
                subFamSelect: false,
                planSelect: false,
                branchSelect: false,
              };
              this.$swal.close();
            });
            this.$swal.fire({
              title: "Exito!",
              text: "La membresía fue eliminada de forma satisfactoria",
              icon: "success",
              showConfirmButton: true,
              confirmButtonColor: "#6bd098",
            });
          } else {
            this.$swal.fire({
              title: "Ha Ocurrido un error! :(",
              text: "Por favor vuelve a intentarlo",
              icon: "error",
              showConfirmButton: true,
              confirmButtonColor: "#6bd098",
            });
            this.isLoaded = true;
          }
          // console.log("Resultado Eliminción");
          // console.log(resp);
        } catch (ex) {
          console.error("Error");
          console.error(ex);
          this.$swal.fire({
            title: "Error! :(",
            text: "Ha ocurrido un error al eliminar la membresía, por favor vuelve a intentarlo mas tarde, o ponte en contacto con soporte",
            confirmButtonColor: "#6bd098",
          });
          this.MAModals = {
            starter: false,
            famSelect: false,
            subFamSelect: false,
            planSelect: false,
            branchSelect: false,
          };
          this.isLoaded = true;
        }
      }
    },
    async memberDetails(row, column, event) {
      // console.log("activate");
      // const socioId = row.id;
      const rut = row.rut;
      this.$swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.cancelMembershipEdit();
      this.isLoaded = false;
      try {
        Promise.all([
          this.getMemberAvatar(rut),
          this.getMemberInfo(rut),
          this.getMembershipInfo(rut),
          this.getMemberAccesResum(rut),
        ]).then(() => {
          this.isLoaded = true;
          this.showDetails = true;
          this.$swal.close();
        });
      } catch (error) {
        console.error("Error: [memberDetails] - ", error);
      } finally {
        window.scrollTo({ top: 100, behavior: "smooth" });
      }
    },
    enableMembershipEdit() {
      // console.log("this.foundMember.type");
      // console.log(this.foundMember.type);
      if (this.foundMember.type === "CARGA") {
        return;
      }
      this.foundMembershipOG = _.cloneDeep(this.foundMembership);
      this.membershipReadOnly = false;
    },
    cancelMembershipEdit() {
      this.foundMembership = { ...this.foundMembershipOG };
      this.membershipReadOnly = true;
      this.foundMembershipOG = {};
      this.foundMemberAccesResum = {};
    },
    async saveMembershipChanges() {
      let updatedFields = {};
      let shiftWasUpdated = false;
      try {
        // Object.keys(this.foundMembership).forEach((key) => {
        //   if (
        //     !_.isEqual(this.foundMembership[key], this.foundMembershipOG[key])
        //   ) {
        //     updatedFields[key] = this.foundMembership[key];
        //   }
        // });
        Object.keys(this.foundMembership).forEach((key) => {
          if (
            !_.isEqual(this.foundMembership[key], this.foundMembershipOG[key])
          ) {
            // console.log(key);
            if (key === "turno") {
              // console.log("turno modificado");
              shiftWasUpdated = true;
            }
            updatedFields[key] = this.foundMembership[key];
          }
        });
        if (updatedFields.fechaAsignacion) {
          const date = new Date(updatedFields.fechaAsignacion);
          updatedFields.fechaAsignacion = date.toISOString();
        }
      } catch (error) {
        console.error(error);
      }
      if (Object.keys(updatedFields).length > 0) {
        this.$swal.fire({
          title: "¿Estás seguro?",
          text: `Has modificado: ${Object.keys(updatedFields).join(",")}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#6bd098",
          cancelButtonColor: "#eb6532",
          confirmButtonText: "Sí, guardar cambios",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateMembership(updatedFields, shiftWasUpdated); // Método que guarda los cambios
          } else {
            this.cancelMembershipEdit();
          }
        });
      } else {
        // console.warn("SIN MODIFICACIONES");
        this.$swal.fire({
          title: "No hay Cambios",
          text: "No tienes cambios que guardar",
          icon: "info",
          confirmButtonText: "entendido",
          customClass: {
            confirmButton: "btn btn-success",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.cancelMembershipEdit(); // Método que guarda los cambios
          }
        });
      }
    },
    async updateMembership(updatedFields, updateShift) {
      this.$swal.fire({
        title: "Actualizando...",
        text: "Por favor espera",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      var { __v, _id, createdAt, updatedAt, estadoPago, ...updatedMembership } =
        this.foundMembership;
      updatedMembership.estadoPlan = estadoPago;
      if (updateShift) {
        Object.keys(updatedMembership.turno).forEach((key) => {
          switch (true) {
            case /Hora/.test(key):
              // Realizar validación con expresión regular
              let valor = updatedMembership.turno[key]
                ? updatedMembership.turno[key]
                : "00:00:00";
              const formatoIncompleto = /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(
                valor
              );

              valor = formatoIncompleto ? valor + ":00" : valor;
              updatedMembership.turno[key] = valor;
              break;
            default:
              break;
          }
        });
        updatedMembership.indicadorActualizarTurno = true;
      }
      // updatedMembership.tipoPlan = convenio
      try {
        const result = await this.$MasterControlAPI.post(
          "",
          {
            Header: {
              Operacion: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .UpdateMembershipAPIv3,
            },
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Parameters: {
              idSucursal: sessionStorage.getItem("nu5za9cv6q"),
              nombreSucursal: sessionStorage.getItem("qtsb4ec3d8"),
              rut: this.foundMembership.rutSocio,
              tipoPlan: "PRINCIPAL",
            },
            Body: updatedMembership,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(result.data.Response);
        this.$swal.close();
        if (
          result.data.Response.Resultado.CodigoHTTP === 201 ||
          result.data.Response.Resultado.CodigoHTTP === 200
        ) {
          this.foundMembershipOG = this.foundMembership;
          this.membershipReadOnly = true;
          this.$swal.fire({
            title: "OK!",
            text: "Haz modificado la membresía de forma exitosa",
            icon: "success",
            confirmButtonColor: "#6bd098",
            confirmButtonText: "ok",
          }).then((result) => {
            // if (result.isConfirmed) {
            //   this.updateMembership(updatedFields); // Método que guarda los cambios
            // } else {
            //   this.cancelMembershipEdit();
            // }
          });
        } else {
          this.foundMembershipOG = this.foundMembership;
          this.membershipReadOnly = true;
          this.$swal.fire({
            title: "ERROR!",
            text: result.data.Response.Resultado.MensajeInterno,
            icon: "warning",
            confirmButtonColor: "#eb6532",
            confirmButtonText: "ok",
          });
        }
      } catch (error) {
        this.$swal.close();

        this.$swal.fire({
          title: "ERROR!",
          text: error.message,
          icon: "warning",
          confirmButtonColor: "#eb6532",
          confirmButtonText: "ok",
        });
        console.error("Error: ", error.message);
      }
    },
    async getMemberAccesResum(id) {
      // try {
      //   const result = await this.$MasterControlAPP.post(
      //     "",
      //     {
      //       Parameters: { nationalId: id },
      //     },
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         token: sessionStorage.getItem("jCxbraoQeD"),
      //         // operation: "/v1/get/access/resum",
      //         operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
      //           .GetAccessResum,
      //       },
      //     }
      //   );
      //   if (result.data.lastAcces) {
      //     const splitedDate = result.data.lastAccess.fechaIngreso.split("-");
      //     const splitedTime = result.data.lastAccess.horaIngreso.split(":");
      //     const formatedDate = `${splitedDate[0]}-${splitedDate[1]}`;
      //     const formatedTime = `${splitedTime[0]}:${splitedTime[1]}`;
      //     this.foundMemberAccesResum.latestAccess = `${formatedDate} a las ${formatedTime}Hrs`;
      //     this.foundMemberAccesResum.bestDaysOfWeek =
      //       result.data.bestDaysOfWeek;
      //     this.foundMemberAccesResum.bestBranch = result.data.bestBranch;
      //   }
      //   console.log("getMemberAccesResum done", result.data);
      //   // console.log(this.foundMemberAccesResum.bestDaysOfWeek);
      //   // console.log(result.data);
      // } catch (ex) {
      //   console.error("Error: ", ex);
      // }
    },
    async backToSearch() {
      this.getMemberships(0);
    },
    async getFamilysCatalog() {
      this.familysCatalog = [];
      this.updateFilters = false;
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/familyscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetFamilysCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          this.familysCatalog = [{ _id: false, nombre: "TODAS" }, ...resp.data];
          this.selectedFamily = this.selectedFamily
            ? this.selectedFamily
            : this.familysCatalog[0].nombre;
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
    async getSubFamilysCatalog() {
      // console.log("calling");
      this.subFamilysCatalog = [];
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              idFamilia: this.filters.family,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/subfamilyscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetSubFamilysCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          this.subFamilysCatalog = [
            { _id: false, nombre: "TODAS", idFamilia: false },
            ...resp.data,
          ];
          this.selectedSubFamily = this.selectedSubFamily
            ? this.selectedSubFamily
            : this.subFamilysCatalog[0].nombre;
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
    async getPlansCatalog() {
      this.subFamilysCatalog = [];
      try {
        const resp = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {
              idFamilia: this.filters.family,
              idSubFamilia: this.filters.subFamily,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              // operation: "/v1/get/planscatalog",
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .GetPlansCatalog,
            },
          }
        );
        // console.log(resp);
        if (resp.data.length > 0) {
          this.plansCatalog = [
            {
              _id: false,
              nombre: "TODAS",
              familia: false,
              idSubFamilia: false,
            },
            ...resp.data,
          ];
          this.selectedPlan = this.selectedPlan
            ? this.selectedPlan
            : this.plansCatalog[0].nombre;
          return resp.data;
        } else {
          console.error("Error en la llamada, respuesta vacía");
        }
      } catch (error) {
        console.error("ERROR: ", error.message);
      }
    },
  },
  beforeMount() {
    this.currentFilter = this.$store.getters.getMembershipFilter;
    this.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    if (this.$store.getters.getMembershipsDDtag) {
      this.pagination.currentFilter = this.$store.getters.getMembershipsDDtag;
    }
    // console.log("this.currentFilter");
    // console.log(this.currentFilter);
  },
  mounted() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    const nid = this.$store.getters.getCosturmerNIDcustomersAndMemberhipsFilter;
    this.$nextTick(() => {
      // console.log("mounted");
      if (nid) {
        Promise.all([
          this.getCatalog(),
          this.getMemberships(0),
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getPlansCatalogs(),
          this.memberDetails({ rut: nid }),
        ]).then(() => {
          this.$store.commit("setCosturmerNIDcustomersAndMemberhipsFilter", "");
          if (this.activeMembershipID && this.foundMember.type != "CARGA") {
            this.enableMembershipEdit();
          } else {
            if (this.foundMember.type === "CARGA") {
              return;
            } else {
              this.memebrshipAsingmentStart();
            }
          }
          this.$swal.close();
          this.isMounted = true;
        });
      } else {
        Promise.all([
          this.getCatalog(),
          this.getMemberships(0),
          this.getFamilysCatalog(),
          this.getSubFamilysCatalog(),
          this.getPlansCatalog(),
          this.getPlansCatalogs(),
        ]).then(() => {
          this.$swal.close();
          this.isMounted = true;
        });
      }
    });
  },
  beforeDestroy() {
    // Modal de carga removido - causaba problemas de persistencia
    // al navegar entre componentes. Los componentes de destino manejan
    // su propia carga con spinners internos.
  },
  destroyed() {
    this.$store.commit("setMembershipFilter", "");
    this.$store.commit("setMembershipsDDtag", "");
  },
};
</script>

<style>
.table-body {
  display: block; /* Permite que el tbody tenga su propio bloque de formato */
  max-height: 300px; /* Hereda la altura máxima del contenedor padre */
  overflow-y: auto; /* Agrega una barra de desplazamiento vertical si es necesario */
}
.el-table .cell {
  white-space: nowrap !important;
}
.mobile-table-text {
  max-width: 200px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.cursor-pointer:hover {
  cursor: pointer;
  text-shadow: 2px 2px 4px #343a409a;
}
</style>
// async getMemberships(page) { // this.showDetails = false; // let matchStage =
{}; // this.membershipsData = []; // this.tableIsLoading = true; //
this.activeMembershipID = ""; // this.filterResultTotal = 0; // var pipeline; //
var counterFilters = {}; // // console.log(this.currentFilter); // if ( //
!this.currentFilter && // this.filters.plan === false && // this.filters.family
=== false && // this.filters.subFamily === false // ) { // matchStage = {}; //
counterFilters = null; // pipeline = { // dataSource: "DataAPI", // database:
this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod", // collection: "socios", //
pipeline: [ // { // $lookup: { // from: "socio_plan_principal", // La colección
con la que quieres hacer join. // // localField: "rut", // El campo en
colecciónA que se usará para el match. // // foreignField: "rutSocio", // El
campo en colecciónB que se usará para el match. // let: { local_rut: "$rut",
local_empresa: "$empresa" }, // pipeline: [ // { // $match: { // $expr: { //
$and: [ // { $eq: ["$rutSocio", "$$local_rut"] }, // { $eq: ["$empresa",
"$$local_empresa"] }, // ], // }, // }, // }, // ], // as: "plan", // El nombre
del nuevo campo que contendrá la data de colecciónB. // }, // }, // { //
$lookup: { // from: "plan_catalogo_estados_pago", // La colección con la que
quieres hacer join. // localField: "plan.estadoPago", // El campo en colecciónA
que se usará para el match. // foreignField: "_id", // El campo en colecciónB
que se usará para el match. // as: "catalogoEstado", // El nombre del nuevo
campo que contendrá la data de colecciónB. // }, // }, // { // $unwind: { //
path: "$catalogoEstado", // preserveNullAndEmptyArrays: true, // }, //
Descomponer los datos de colecciónB para evitar que estén en un array. // }, //
{ // $match: { ...matchStage }, // }, // { $skip: page ? page * 10 : 0 }, //
Asumiendo que 'page' comienza en 0 para la primera página // // Limitar el
número de documentos // { $limit: 10 }, // { // $unwind: { // path: "$plan", //
preserveNullAndEmptyArrays: true, // }, // Descomponer los datos de colecciónB
para evitar que estén en un array. // }, // { // $addFields: { // // name:
"$dataSocio.nombreSocio", // Crear el nuevo campo con el valor de nombre de
colecciónB. // nombreTurno: { $ifNull: ["$plan.turno.descripcionTurno", false]
}, // descripcionPlan: { $ifNull: ["$plan.descripcionPlan", false] }, //
fechaVencimiento: { $ifNull: ["$plan.fechaVencimiento", false] }, //
glosaEstado: { ifNull: ["$catalogoEstado.glosa", false] }, // }, // }, // { //
$project: { // _id: 1, // nombreSocio: 1, // rut: 1, // descripcionPlan: 1, //
fechaVencimiento: 1, // nombreTurno: 1, // glosaEstado: 1, // rutSocio: 0, //
catalogoEstado: 0, // estadoPago: 0 // }, // }, // { // $sort: { // nombreSocio:
1, // }, // }, // ], // }; // } else { // if (this.currentFilter) { //
matchStage.estadoPago = { $in: this.currentFilter }; //
counterFilters.estadoPago = { $in: this.currentFilter }; // } // // matchStage =
{ // // // "plan.estadoPago": { $oid: this.currentFilter }, // // }; // if
(this.filters.plan !== false) { // matchStage.idPlan = this.filters.plan; //
counterFilters.idPlan = this.filters.plan; // } // if (this.filters.family !==
false) { // matchStage.idFamilia = this.filters.family; //
counterFilters.idFamilia = this.filters.family; // } // if
(this.filters.subFamily !== false) { // matchStage.idSubFamilia =
this.filters.subFamily; // counterFilters.idSubFamilia = this.filters.subFamily;
// } // pipeline = { // dataSource: "membership_statistics", // database:
this.$ToDesa ? "mb3-gym-desa" : "mb3-gym-prod", // collection:
"socio_plan_principal", // pipeline: [ // { // $match: { ...matchStage }, // },
// { // $lookup: { // from: "socios", // La colección con la que quieres hacer
join. // // localField: "rutSocio", // El campo en colecciónA que se usará para
el match. // // foreignField: "rut", // El campo en colecciónB que se usará para
el match. // let: { local_rut: "$rutSocio", local_empresa: "$empresa" }, //
pipeline: [ // { // $match: { // $expr: { // $and: [ // { $eq: ["$rut",
"$$local_rut"] }, // { $eq: ["$empresa", "$$local_empresa"] }, // ], // }, // },
// }, // { $project: { nombreSocio: 1, _id: 1 } }, // ], // // pipeline: [{
$project: { nombreSocio: 1, _id: 1 } }], // as: "socio", // El nombre del nuevo
campo que contendrá la data de colecciónB. // }, // }, // { // $lookup: { //
from: "plan_catalogo_estados_pago", // La colección con la que quieres hacer
join. // localField: "estadoPago", // El campo en colecciónA que se usará para
el match. // foreignField: "_id", // El campo en colecciónB que se usará para el
match. // as: "catalogoEstado", // El nombre del nuevo campo que contendrá la
data de colecciónB. // }, // }, // { // $unwind: { // path: "$catalogoEstado",
// preserveNullAndEmptyArrays: true, // }, // Descomponer los datos de
colecciónB para evitar que estén en un array. // }, // { $skip: page ? page * 10
: 0 }, // Asumiendo que 'page' comienza en 0 para la primera página // //
Limitar el número de documentos // { $limit: 10 }, // { // $unwind: { // path:
"$socio", // preserveNullAndEmptyArrays: true, // }, // Descomponer los datos de
colecciónB para evitar que estén en un array. // }, // { // $addFields: { // //
name: "$dataSocio.nombreSocio", // Crear el nuevo campo con el valor de nombre
de colecciónB. // nombreTurno: "$turno.descripcionTurno", // // descripcionPlan:
"$plan.descripcionPlan", // // fechaVencimiento: "$plan.fechaVencimiento", //
glosaEstado: "$catalogoEstado.glosa", // nombreSocio: "$socio.nombreSocio", //
rut: "$rutSocio", // _id: "$socio._id", // }, // }, // { // $project: { // _id:
1, // nombreSocio: 1, // rut: 1, // descripcionPlan: 1, // fechaVencimiento: 1,
// nombreTurno: 1, // glosaEstado: 1, // }, // }, // { // $sort: { //
nombreSocio: 1, // }, // }, // ], // }; // } // // console.log("matchStage"); //
// console.log(matchStage); // try { // const memberships = await
this.$MasterControlAPP.post("", pipeline, { // headers: { // "Content-Type":
"application/json", // token: sessionStorage.getItem("jCxbraoQeD"), //
operation: "/data/v1/action/aggregate", // // operation:
JSON.parse(sessionStorage.getItem("wxZlBbdD4q")) // // .AccessStatistics, // },
// }); // // const count = await this.$MasterControlAPP.post( // // "", // // {
// // Parameters: { matchStage: this.currentFilter }, // // }, // // { // //
headers: { // // "Content-Type": "application/json", // // token:
sessionStorage.getItem("jCxbraoQeD"), // // //operation:
this.getOP("SalesStatistics"), // // operation: "/v1/get/customers", // // }, //
// } // // ); // const count = await this.$MasterControlAPP.post( // "", // { //
Parameters: { filter: counterFilters }, // }, // { // headers: { //
"Content-Type": "application/json", // token:
sessionStorage.getItem("jCxbraoQeD"), // //operation:
this.getOP("SalesStatistics"), // // operation: "/v1/count/customers/filters",
// operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")) //
.CountCustomersFilters, // }, // } // ); // this.pagination.total =
count.data.result; // this.filterResultTotal = count.data.result; //
memberships.data.documents.forEach((item) => { // if (item.nombreSocio) { // var
splitedName = item.nombreSocio.split(" "); // switch (splitedName.length) { //
case 5: // item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`; // break;
// case 4: // item.nombreSocio = `${splitedName[0]} ${splitedName[3]}`; //
break; // case 3: // item.nombreSocio = `${splitedName[0]} ${splitedName[2]}`;
// break; // default: // break; // } // } else { // item.nombreSocio = "[Error
Socio]"; // console.warn("El Plan no hace referencia a un socio real"); // } //
this.membershipsData.push({ // id: item._id, // rut: item.rut, // name:
item.nombreSocio, // membership: item.descripcionPlan || "Sin membresía
Asociado", // status: item.glosaEstado || "----", // expiration:
item.fechaVencimiento || "", // }); // }); // } catch (ex) { //
console.error("***************MEMBERSHIPS"); // console.error(ex); // } finally
{ // this.tableIsLoading = false; // } // },
